// This file is auto-generated by @hey-api/openapi-ts

import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { adoptionsList, agentCredentialsArchive, agentCredentialsGet, agentCredentialsList, agentCredentialsSet, agentCredentialsVerify, agentMessagesList, agentMessagesNew, agentModelsList, agentProfileEdit, agentProfileGet, agentProvidersList, agentSessionsAccept, agentSessionsCancel, agentSessionsGet, agentSessionsList, agentSessionsNew, agentSessionsPause, agentSessionsResume, agentSessionsRevert, aliasesGet, aliasesList, aliasesSet, annotationsNew, approvalsApprove, approvalsDeny, approvalsGet, approvalsList, artifactsEvict, artifactsGet, audioGet, audioSign, auditList, authAccept, authGet, authLogin, authLogout, authSetup, auxiliariesGet, auxiliariesList, backupsGet, backupsList, backupsNew, backupsVerify, baseModelsGet, baseModelsList, batchesFreeze, batchesGet, batchesList, batchesNew, batchItemsAccept, batchItemsGet, batchItemsList, boostEdit, branchesAccept, branchesCompare, branchesGet, branchesList, branchesRevert, bundlesAdopt, checkpointsAverage, checkpointsGet, checkpointsList, collectionsGet, collectionsList, computeEdit, computeGet, computeList, credentialsList, credentialsNew, credentialsRevoke, datasetsEvict, datasetsExport, datasetsFreeze, datasetsGet, datasetsList, datasetsMaterialize, datasetsPreview, defaultsGet, deliveryGet, deploymentsGet, deploymentsList, deploymentsNew, deploymentsPromote, deploymentsRollback, deploymentTargetsArchive, deploymentTargetsEdit, deploymentTargetsGet, deploymentTargetsList, deploymentTargetsNew, draftsAccept, draftsGet, draftsList, draftsRevert, egressHostsList, evalsGate, evalsGet, evalsList, evalsNew, eventsList, experimentsGet, experimentsList, experimentsNew, exportsGet, exportsList, gatesEdit, gatesGet, goldenSetsAlign, goldenSetsFreeze, goldenSetsGet, goldenSetsList, guidelinesGet, helpGet, helpSearch, hostCredentialsClaim, hostCredentialsReport, hostSessionsAsk, hostSessionsClaim, hostSessionsDecision, hostSessionsRelease, hostSessionsReport, invitationsList, invitationsNew, jobLogsList, jobsCancel, jobsEdit, jobsGet, jobsList, jobsPause, jobsResume, jobsWait, langpacksEdit, langpacksGet, langpacksList, meGet, metricsGet, mixesEdit, mixesGet, mixesList, mixesNew, mixesPreview, modelFamiliesGet, modelFamiliesList, modelsBenchmark, modelsExport, modelsGet, modelsList, modelsParity, modelsRegister, mountsGet, mountsList, mountsNew, mountsScan, mountsVerify, normalizersGet, normalizersList, notificationRulesEdit, notificationRulesList, notificationSettingsEdit, notificationSettingsGet, type Options, peaksGet, pipelineRunsCancel, pipelineRunsGet, pipelineRunsList, pipelineRunsRetry, pipelineRunsWait, pipelinesList, pipelinesRun, playbooksGet, playbooksList, playbooksRun, policiesEdit, policiesGet, projectsAdopt, projectsArchive, projectsEdit, projectsExport, projectsGet, projectsList, projectsNew, projectsNote, projectsSearch, projectsSync, promotionsGet, promotionsList, promotionsVerify, queueEntriesList, recipesEdit, recipesGet, recipesList, recipesNew, registryLineage, registrySearch, runsCalibrate, runsGet, runsList, runsNew, runsResume, runsStage, runtimesGet, runtimesList, secretsList, secretsNew, shadowReplaysGet, shadowReplaysList, shadowReplaysNew, sourcesArchive, sourcesEdit, sourcesGet, sourcesList, sourcesNew, spectrogramGet, stepKindsGet, stepKindsList, storageGet, streamConnect, sweepsRun, telegramBotSet, telegramBotVerify, templatesGet, templatesList, textsGet, totpConfirm, totpDisable, totpEnroll, tracksGet, transcriptionsNew, triageAccept, triageCorrect, triageList, triageReject, utterancesGet, utterancesList, utterancesSearch, versionsArchive, viewsGet, viewsList, viewsSet, wordsGet, workerArtifactsSet, workerLeasesClaim, workerLeasesRelease, workerLeasesReport, workerLiveConnect, workerLogsNew, workerMetricsNew, workerOutputsNew, workerRegistrationsNew, workspacesGet, workspacesList, workspacesSet } from '../sdk.gen';
import type { AdoptionsListData, AdoptionsListError, AdoptionsListResponse, AgentCredentialsArchiveData, AgentCredentialsArchiveError, AgentCredentialsArchiveResponse, AgentCredentialsGetData, AgentCredentialsGetError, AgentCredentialsGetResponse, AgentCredentialsListData, AgentCredentialsListError, AgentCredentialsListResponse, AgentCredentialsSetData, AgentCredentialsSetError, AgentCredentialsSetResponse, AgentCredentialsVerifyData, AgentCredentialsVerifyError, AgentCredentialsVerifyResponse, AgentMessagesListData, AgentMessagesListError, AgentMessagesListResponse, AgentMessagesNewData, AgentMessagesNewError, AgentMessagesNewResponse, AgentModelsListData, AgentModelsListError, AgentModelsListResponse, AgentProfileEditData, AgentProfileEditError, AgentProfileEditResponse, AgentProfileGetData, AgentProfileGetError, AgentProfileGetResponse, AgentProvidersListData, AgentProvidersListError, AgentProvidersListResponse, AgentSessionsAcceptData, AgentSessionsAcceptError, AgentSessionsAcceptResponse, AgentSessionsCancelData, AgentSessionsCancelError, AgentSessionsCancelResponse, AgentSessionsGetData, AgentSessionsGetError, AgentSessionsGetResponse, AgentSessionsListData, AgentSessionsListError, AgentSessionsListResponse, AgentSessionsNewData, AgentSessionsNewError, AgentSessionsNewResponse, AgentSessionsPauseData, AgentSessionsPauseError, AgentSessionsPauseResponse, AgentSessionsResumeData, AgentSessionsResumeError, AgentSessionsResumeResponse, AgentSessionsRevertData, AgentSessionsRevertError, AgentSessionsRevertResponse, AliasesGetData, AliasesGetError, AliasesGetResponse, AliasesListData, AliasesListError, AliasesListResponse, AliasesSetData, AliasesSetError, AliasesSetResponse, AnnotationsNewData, AnnotationsNewError, AnnotationsNewResponse, ApprovalsApproveData, ApprovalsApproveError, ApprovalsApproveResponse, ApprovalsDenyData, ApprovalsDenyError, ApprovalsDenyResponse, ApprovalsGetData, ApprovalsGetError, ApprovalsGetResponse, ApprovalsListData, ApprovalsListError, ApprovalsListResponse, ArtifactsEvictData, ArtifactsEvictError, ArtifactsEvictResponse, ArtifactsGetData, ArtifactsGetError, ArtifactsGetResponse, AudioGetData, AudioGetError, AudioGetResponse, AudioSignData, AudioSignError, AudioSignResponse, AuditListData, AuditListError, AuditListResponse, AuthAcceptData, AuthAcceptError, AuthAcceptResponse, AuthGetData, AuthGetError, AuthGetResponse, AuthLoginData, AuthLoginError, AuthLoginResponse, AuthLogoutData, AuthLogoutError, AuthLogoutResponse, AuthSetupData, AuthSetupError, AuthSetupResponse, AuxiliariesGetData, AuxiliariesGetError, AuxiliariesGetResponse, AuxiliariesListData, AuxiliariesListError, AuxiliariesListResponse, BackupsGetData, BackupsGetError, BackupsGetResponse, BackupsListData, BackupsListError, BackupsListResponse, BackupsNewData, BackupsNewError, BackupsNewResponse, BackupsVerifyData, BackupsVerifyError, BackupsVerifyResponse, BaseModelsGetData, BaseModelsGetError, BaseModelsGetResponse, BaseModelsListData, BaseModelsListError, BaseModelsListResponse, BatchesFreezeData, BatchesFreezeError, BatchesFreezeResponse, BatchesGetData, BatchesGetError, BatchesGetResponse, BatchesListData, BatchesListError, BatchesListResponse, BatchesNewData, BatchesNewError, BatchesNewResponse, BatchItemsAcceptData, BatchItemsAcceptError, BatchItemsAcceptResponse, BatchItemsGetData, BatchItemsGetError, BatchItemsGetResponse, BatchItemsListData, BatchItemsListError, BatchItemsListResponse, BoostEditData, BoostEditError, BoostEditResponse, BranchesAcceptData, BranchesAcceptError, BranchesAcceptResponse, BranchesCompareData, BranchesCompareError, BranchesCompareResponse, BranchesGetData, BranchesGetError, BranchesGetResponse, BranchesListData, BranchesListError, BranchesListResponse, BranchesRevertData, BranchesRevertError, BranchesRevertResponse, BundlesAdoptData, BundlesAdoptError, BundlesAdoptResponse, CheckpointsAverageData, CheckpointsAverageError, CheckpointsAverageResponse, CheckpointsGetData, CheckpointsGetError, CheckpointsGetResponse, CheckpointsListData, CheckpointsListError, CheckpointsListResponse, CollectionsGetData, CollectionsGetError, CollectionsGetResponse, CollectionsListData, CollectionsListError, CollectionsListResponse, ComputeEditData, ComputeEditError, ComputeEditResponse, ComputeGetData, ComputeGetError, ComputeGetResponse, ComputeListData, ComputeListError, ComputeListResponse, CredentialsListData, CredentialsListError, CredentialsListResponse, CredentialsNewData, CredentialsNewError, CredentialsNewResponse, CredentialsRevokeData, CredentialsRevokeError, CredentialsRevokeResponse, DatasetsEvictData, DatasetsEvictError, DatasetsEvictResponse, DatasetsExportData, DatasetsExportError, DatasetsExportResponse, DatasetsFreezeData, DatasetsFreezeError, DatasetsFreezeResponse, DatasetsGetData, DatasetsGetError, DatasetsGetResponse, DatasetsListData, DatasetsListError, DatasetsListResponse, DatasetsMaterializeData, DatasetsMaterializeError, DatasetsMaterializeResponse, DatasetsPreviewData, DatasetsPreviewError, DatasetsPreviewResponse, DefaultsGetData, DefaultsGetError, DefaultsGetResponse, DeliveryGetData, DeliveryGetError, DeliveryGetResponse, DeploymentsGetData, DeploymentsGetError, DeploymentsGetResponse, DeploymentsListData, DeploymentsListError, DeploymentsListResponse, DeploymentsNewData, DeploymentsNewError, DeploymentsNewResponse, DeploymentsPromoteData, DeploymentsPromoteError, DeploymentsPromoteResponse, DeploymentsRollbackData, DeploymentsRollbackError, DeploymentsRollbackResponse, DeploymentTargetsArchiveData, DeploymentTargetsArchiveError, DeploymentTargetsArchiveResponse, DeploymentTargetsEditData, DeploymentTargetsEditError, DeploymentTargetsEditResponse, DeploymentTargetsGetData, DeploymentTargetsGetError, DeploymentTargetsGetResponse, DeploymentTargetsListData, DeploymentTargetsListError, DeploymentTargetsListResponse, DeploymentTargetsNewData, DeploymentTargetsNewError, DeploymentTargetsNewResponse, DraftsAcceptData, DraftsAcceptError, DraftsAcceptResponse, DraftsGetData, DraftsGetError, DraftsGetResponse, DraftsListData, DraftsListError, DraftsListResponse, DraftsRevertData, DraftsRevertError, DraftsRevertResponse, EgressHostsListData, EgressHostsListError, EgressHostsListResponse, EvalsGateData, EvalsGateError, EvalsGateResponse, EvalsGetData, EvalsGetError, EvalsGetResponse, EvalsListData, EvalsListError, EvalsListResponse, EvalsNewData, EvalsNewError, EvalsNewResponse, EventsListData, EventsListError, EventsListResponse, ExperimentsGetData, ExperimentsGetError, ExperimentsGetResponse, ExperimentsListData, ExperimentsListError, ExperimentsListResponse, ExperimentsNewData, ExperimentsNewError, ExperimentsNewResponse, ExportsGetData, ExportsGetError, ExportsGetResponse, ExportsListData, ExportsListError, ExportsListResponse, GatesEditData, GatesEditError, GatesEditResponse, GatesGetData, GatesGetError, GatesGetResponse, GoldenSetsAlignData, GoldenSetsAlignError, GoldenSetsAlignResponse, GoldenSetsFreezeData, GoldenSetsFreezeError, GoldenSetsFreezeResponse, GoldenSetsGetData, GoldenSetsGetError, GoldenSetsGetResponse, GoldenSetsListData, GoldenSetsListError, GoldenSetsListResponse, GuidelinesGetData, GuidelinesGetError, GuidelinesGetResponse, HelpGetData, HelpGetError, HelpGetResponse, HelpSearchData, HelpSearchError, HelpSearchResponse, HostCredentialsClaimData, HostCredentialsClaimError, HostCredentialsClaimResponse, HostCredentialsReportData, HostCredentialsReportError, HostCredentialsReportResponse, HostSessionsAskData, HostSessionsAskError, HostSessionsAskResponse, HostSessionsClaimData, HostSessionsClaimError, HostSessionsClaimResponse, HostSessionsDecisionData, HostSessionsDecisionError, HostSessionsDecisionResponse, HostSessionsReleaseData, HostSessionsReleaseError, HostSessionsReleaseResponse, HostSessionsReportData, HostSessionsReportError, HostSessionsReportResponse, InvitationsListData, InvitationsListError, InvitationsListResponse, InvitationsNewData, InvitationsNewError, InvitationsNewResponse, JobLogsListData, JobLogsListError, JobLogsListResponse, JobsCancelData, JobsCancelError, JobsCancelResponse, JobsEditData, JobsEditError, JobsEditResponse, JobsGetData, JobsGetError, JobsGetResponse, JobsListData, JobsListError, JobsListResponse, JobsPauseData, JobsPauseError, JobsPauseResponse, JobsResumeData, JobsResumeError, JobsResumeResponse, JobsWaitData, JobsWaitError, JobsWaitResponse, LangpacksEditData, LangpacksEditError, LangpacksEditResponse, LangpacksGetData, LangpacksGetError, LangpacksGetResponse, LangpacksListData, LangpacksListError, LangpacksListResponse, MeGetData, MeGetError, MeGetResponse, MetricsGetData, MetricsGetError, MetricsGetResponse, MixesEditData, MixesEditError, MixesEditResponse, MixesGetData, MixesGetError, MixesGetResponse, MixesListData, MixesListError, MixesListResponse, MixesNewData, MixesNewError, MixesNewResponse, MixesPreviewData, MixesPreviewError, MixesPreviewResponse, ModelFamiliesGetData, ModelFamiliesGetError, ModelFamiliesGetResponse, ModelFamiliesListData, ModelFamiliesListError, ModelFamiliesListResponse, ModelsBenchmarkData, ModelsBenchmarkError, ModelsBenchmarkResponse, ModelsExportData, ModelsExportError, ModelsExportResponse, ModelsGetData, ModelsGetError, ModelsGetResponse, ModelsListData, ModelsListError, ModelsListResponse, ModelsParityData, ModelsParityError, ModelsParityResponse, ModelsRegisterData, ModelsRegisterError, ModelsRegisterResponse, MountsGetData, MountsGetError, MountsGetResponse, MountsListData, MountsListError, MountsListResponse, MountsNewData, MountsNewError, MountsNewResponse, MountsScanData, MountsScanError, MountsScanResponse, MountsVerifyData, MountsVerifyError, MountsVerifyResponse, NormalizersGetData, NormalizersGetError, NormalizersGetResponse, NormalizersListData, NormalizersListError, NormalizersListResponse, NotificationRulesEditData, NotificationRulesEditError, NotificationRulesEditResponse, NotificationRulesListData, NotificationRulesListError, NotificationRulesListResponse, NotificationSettingsEditData, NotificationSettingsEditError, NotificationSettingsEditResponse, NotificationSettingsGetData, NotificationSettingsGetError, NotificationSettingsGetResponse, PeaksGetData, PeaksGetError, PeaksGetResponse, PipelineRunsCancelData, PipelineRunsCancelError, PipelineRunsCancelResponse, PipelineRunsGetData, PipelineRunsGetError, PipelineRunsGetResponse, PipelineRunsListData, PipelineRunsListError, PipelineRunsListResponse, PipelineRunsRetryData, PipelineRunsRetryError, PipelineRunsRetryResponse, PipelineRunsWaitData, PipelineRunsWaitError, PipelineRunsWaitResponse, PipelinesListData, PipelinesListError, PipelinesListResponse, PipelinesRunData, PipelinesRunError, PipelinesRunResponse, PlaybooksGetData, PlaybooksGetError, PlaybooksGetResponse, PlaybooksListData, PlaybooksListError, PlaybooksListResponse, PlaybooksRunData, PlaybooksRunError, PlaybooksRunResponse, PoliciesEditData, PoliciesEditError, PoliciesEditResponse, PoliciesGetData, PoliciesGetError, PoliciesGetResponse, ProjectsAdoptData, ProjectsAdoptError, ProjectsAdoptResponse, ProjectsArchiveData, ProjectsArchiveError, ProjectsArchiveResponse, ProjectsEditData, ProjectsEditError, ProjectsEditResponse, ProjectsExportData, ProjectsExportError, ProjectsExportResponse, ProjectsGetData, ProjectsGetError, ProjectsGetResponse, ProjectsListData, ProjectsListError, ProjectsListResponse, ProjectsNewData, ProjectsNewError, ProjectsNewResponse, ProjectsNoteData, ProjectsNoteError, ProjectsNoteResponse, ProjectsSearchData, ProjectsSearchError, ProjectsSearchResponse, ProjectsSyncData, ProjectsSyncError, ProjectsSyncResponse, PromotionsGetData, PromotionsGetError, PromotionsGetResponse, PromotionsListData, PromotionsListError, PromotionsListResponse, PromotionsVerifyData, PromotionsVerifyError, PromotionsVerifyResponse, QueueEntriesListData, QueueEntriesListError, QueueEntriesListResponse, RecipesEditData, RecipesEditError, RecipesEditResponse, RecipesGetData, RecipesGetError, RecipesGetResponse, RecipesListData, RecipesListError, RecipesListResponse, RecipesNewData, RecipesNewError, RecipesNewResponse, RegistryLineageData, RegistryLineageError, RegistryLineageResponse, RegistrySearchData, RegistrySearchError, RegistrySearchResponse, RunsCalibrateData, RunsCalibrateError, RunsCalibrateResponse, RunsGetData, RunsGetError, RunsGetResponse, RunsListData, RunsListError, RunsListResponse, RunsNewData, RunsNewError, RunsNewResponse, RunsResumeData, RunsResumeError, RunsResumeResponse, RunsStageData, RunsStageError, RunsStageResponse, RuntimesGetData, RuntimesGetError, RuntimesGetResponse, RuntimesListData, RuntimesListError, RuntimesListResponse, SecretsListData, SecretsListError, SecretsListResponse, SecretsNewData, SecretsNewError, SecretsNewResponse, ShadowReplaysGetData, ShadowReplaysGetError, ShadowReplaysGetResponse, ShadowReplaysListData, ShadowReplaysListError, ShadowReplaysListResponse, ShadowReplaysNewData, ShadowReplaysNewError, ShadowReplaysNewResponse, SourcesArchiveData, SourcesArchiveError, SourcesArchiveResponse, SourcesEditData, SourcesEditError, SourcesEditResponse, SourcesGetData, SourcesGetError, SourcesGetResponse, SourcesListData, SourcesListError, SourcesListResponse, SourcesNewData, SourcesNewError, SourcesNewResponse, SpectrogramGetData, SpectrogramGetError, SpectrogramGetResponse, StepKindsGetData, StepKindsGetError, StepKindsGetResponse, StepKindsListData, StepKindsListError, StepKindsListResponse, StorageGetData, StorageGetError, StorageGetResponse, StreamConnectData, StreamConnectError, StreamConnectResponse, SweepsRunData, SweepsRunError, SweepsRunResponse, TelegramBotSetData, TelegramBotSetError, TelegramBotSetResponse, TelegramBotVerifyData, TelegramBotVerifyError, TelegramBotVerifyResponse, TemplatesGetData, TemplatesGetError, TemplatesGetResponse, TemplatesListData, TemplatesListError, TemplatesListResponse, TextsGetData, TextsGetError, TextsGetResponse, TotpConfirmData, TotpConfirmError, TotpConfirmResponse, TotpDisableData, TotpDisableError, TotpDisableResponse, TotpEnrollData, TotpEnrollError, TotpEnrollResponse, TracksGetData, TracksGetError, TracksGetResponse, TranscriptionsNewData, TranscriptionsNewError, TranscriptionsNewResponse, TriageAcceptData, TriageAcceptError, TriageAcceptResponse, TriageCorrectData, TriageCorrectError, TriageCorrectResponse, TriageListData, TriageListError, TriageListResponse, TriageRejectData, TriageRejectError, TriageRejectResponse, UtterancesGetData, UtterancesGetError, UtterancesGetResponse, UtterancesListData, UtterancesListError, UtterancesListResponse, UtterancesSearchData, UtterancesSearchError, UtterancesSearchResponse, VersionsArchiveData, VersionsArchiveError, VersionsArchiveResponse, ViewsGetData, ViewsGetError, ViewsGetResponse, ViewsListData, ViewsListError, ViewsListResponse, ViewsSetData, ViewsSetError, ViewsSetResponse, WordsGetData, WordsGetError, WordsGetResponse, WorkerArtifactsSetData, WorkerArtifactsSetError, WorkerArtifactsSetResponse, WorkerLeasesClaimData, WorkerLeasesClaimError, WorkerLeasesClaimResponse, WorkerLeasesReleaseData, WorkerLeasesReleaseError, WorkerLeasesReleaseResponse, WorkerLeasesReportData, WorkerLeasesReportError, WorkerLeasesReportResponse, WorkerLiveConnectData, WorkerLiveConnectError, WorkerLiveConnectResponse, WorkerLogsNewData, WorkerLogsNewError, WorkerLogsNewResponse, WorkerMetricsNewData, WorkerMetricsNewError, WorkerMetricsNewResponse, WorkerOutputsNewData, WorkerOutputsNewError, WorkerOutputsNewResponse, WorkerRegistrationsNewData, WorkerRegistrationsNewError, WorkerRegistrationsNewResponse, WorkspacesGetData, WorkspacesGetError, WorkspacesGetResponse, WorkspacesListData, WorkspacesListError, WorkspacesListResponse, WorkspacesSetData, WorkspacesSetError, WorkspacesSetResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const projectsListQueryKey = (options?: Options<ProjectsListData>) => createQueryKey('projectsList', options);

/**
 * List projects
 */
export const projectsListOptions = (options?: Options<ProjectsListData>) => queryOptions<ProjectsListResponse, ProjectsListError, ProjectsListResponse, ReturnType<typeof projectsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsListQueryKey(options)
});

/**
 * Create a project from the wizard's choices and bootstrap its repository (202 with the bootstrap job)
 */
export const projectsNewMutation = (options?: Partial<Options<ProjectsNewData>>): UseMutationOptions<ProjectsNewResponse, ProjectsNewError, Options<ProjectsNewData>> => {
    const mutationOptions: UseMutationOptions<ProjectsNewResponse, ProjectsNewError, Options<ProjectsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const projectsGetQueryKey = (options: Options<ProjectsGetData>) => createQueryKey('projectsGet', options);

/**
 * Get a project
 */
export const projectsGetOptions = (options: Options<ProjectsGetData>) => queryOptions<ProjectsGetResponse, ProjectsGetError, ProjectsGetResponse, ReturnType<typeof projectsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsGetQueryKey(options)
});

/**
 * Change a project's name, description, locales, domain, base model or budgets
 */
export const projectsEditMutation = (options?: Partial<Options<ProjectsEditData>>): UseMutationOptions<ProjectsEditResponse, ProjectsEditError, Options<ProjectsEditData>> => {
    const mutationOptions: UseMutationOptions<ProjectsEditResponse, ProjectsEditError, Options<ProjectsEditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsEdit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive a project (soft; reversible)
 */
export const projectsArchiveMutation = (options?: Partial<Options<ProjectsArchiveData>>): UseMutationOptions<ProjectsArchiveResponse, ProjectsArchiveError, Options<ProjectsArchiveData>> => {
    const mutationOptions: UseMutationOptions<ProjectsArchiveResponse, ProjectsArchiveError, Options<ProjectsArchiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsArchive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const meGetQueryKey = (options?: Options<MeGetData>) => createQueryKey('meGet', options);

/**
 * The current actor
 */
export const meGetOptions = (options?: Options<MeGetData>) => queryOptions<MeGetResponse, MeGetError, MeGetResponse, ReturnType<typeof meGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await meGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: meGetQueryKey(options)
});

export const workspacesListQueryKey = (options: Options<WorkspacesListData>) => createQueryKey('workspacesList', options);

/**
 * The user's saved workspaces in a project (names and revisions, no layouts)
 */
export const workspacesListOptions = (options: Options<WorkspacesListData>) => queryOptions<WorkspacesListResponse, WorkspacesListError, WorkspacesListResponse, ReturnType<typeof workspacesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await workspacesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: workspacesListQueryKey(options)
});

export const workspacesGetQueryKey = (options: Options<WorkspacesGetData>) => createQueryKey('workspacesGet', options);

/**
 * Get a saved workspace
 */
export const workspacesGetOptions = (options: Options<WorkspacesGetData>) => queryOptions<WorkspacesGetResponse, WorkspacesGetError, WorkspacesGetResponse, ReturnType<typeof workspacesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await workspacesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: workspacesGetQueryKey(options)
});

/**
 * Save a workspace layout (If-Match; omit it only to create)
 */
export const workspacesSetMutation = (options?: Partial<Options<WorkspacesSetData>>): UseMutationOptions<WorkspacesSetResponse, WorkspacesSetError, Options<WorkspacesSetData>> => {
    const mutationOptions: UseMutationOptions<WorkspacesSetResponse, WorkspacesSetError, Options<WorkspacesSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await workspacesSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const eventsListQueryKey = (options?: Options<EventsListData>) => createQueryKey('eventsList', options);

/**
 * Events after a sequence number; with Accept text/event-stream, the live stream
 */
export const eventsListOptions = (options?: Options<EventsListData>) => queryOptions<EventsListResponse, EventsListError, EventsListResponse, ReturnType<typeof eventsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await eventsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: eventsListQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const eventsListInfiniteQueryKey = (options?: Options<EventsListData>): QueryKey<Options<EventsListData>> => createQueryKey('eventsList', options, true);

/**
 * Events after a sequence number; with Accept text/event-stream, the live stream
 */
export const eventsListInfiniteOptions = (options?: Options<EventsListData>) => {
    const opts = infiniteQueryOptions<EventsListResponse, EventsListError, InfiniteData<EventsListResponse>, QueryKey<Options<EventsListData>>, number | Pick<QueryKey<Options<EventsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<EventsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await eventsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: eventsListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const helpSearchQueryKey = (options?: Options<HelpSearchData>) => createQueryKey('helpSearch', options);

/**
 * Search help articles by text or by context (panel, step kind, error type, field)
 */
export const helpSearchOptions = (options?: Options<HelpSearchData>) => queryOptions<HelpSearchResponse, HelpSearchError, HelpSearchResponse, ReturnType<typeof helpSearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await helpSearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: helpSearchQueryKey(options)
});

export const helpGetQueryKey = (options: Options<HelpGetData>) => createQueryKey('helpGet', options);

/**
 * Get a help article (markdown)
 */
export const helpGetOptions = (options: Options<HelpGetData>) => queryOptions<HelpGetResponse, HelpGetError, HelpGetResponse, ReturnType<typeof helpGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await helpGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: helpGetQueryKey(options)
});

export const registrySearchQueryKey = (options?: Options<RegistrySearchData>) => createQueryKey('registrySearch', options);

/**
 * Search registry versions of every kind by text and qualifiers (kind:, tag:, locale:, state:)
 */
export const registrySearchOptions = (options?: Options<RegistrySearchData>) => queryOptions<RegistrySearchResponse, RegistrySearchError, RegistrySearchResponse, ReturnType<typeof registrySearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await registrySearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: registrySearchQueryKey(options)
});

export const authGetQueryKey = (options?: Options<AuthGetData>) => createQueryKey('authGet', options);

/**
 * Sign-in state — whether first start is pending and who is signed in
 */
export const authGetOptions = (options?: Options<AuthGetData>) => queryOptions<AuthGetResponse, AuthGetError, AuthGetResponse, ReturnType<typeof authGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authGetQueryKey(options)
});

/**
 * First start — set the admin password once and sign in; refused (409) once a password is set
 */
export const authSetupMutation = (options?: Partial<Options<AuthSetupData>>): UseMutationOptions<AuthSetupResponse, AuthSetupError, Options<AuthSetupData>> => {
    const mutationOptions: UseMutationOptions<AuthSetupResponse, AuthSetupError, Options<AuthSetupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authSetup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sign in with username, password and, when enabled, a TOTP code; rate-limited per address and username
 */
export const authLoginMutation = (options?: Partial<Options<AuthLoginData>>): UseMutationOptions<AuthLoginResponse, AuthLoginError, Options<AuthLoginData>> => {
    const mutationOptions: UseMutationOptions<AuthLoginResponse, AuthLoginError, Options<AuthLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sign out — revoke this browser's session and clear its cookie
 */
export const authLogoutMutation = (options?: Partial<Options<AuthLogoutData>>): UseMutationOptions<AuthLogoutResponse, AuthLogoutError, Options<AuthLogoutData>> => {
    const mutationOptions: UseMutationOptions<AuthLogoutResponse, AuthLogoutError, Options<AuthLogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authLogout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start TOTP enrollment for the signed-in user — a new secret, active once confirmed
 */
export const totpEnrollMutation = (options?: Partial<Options<TotpEnrollData>>): UseMutationOptions<TotpEnrollResponse, TotpEnrollError, Options<TotpEnrollData>> => {
    const mutationOptions: UseMutationOptions<TotpEnrollResponse, TotpEnrollError, Options<TotpEnrollData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await totpEnroll({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm TOTP enrollment with a current code; sign-in asks for a code from then on
 */
export const totpConfirmMutation = (options?: Partial<Options<TotpConfirmData>>): UseMutationOptions<TotpConfirmResponse, TotpConfirmError, Options<TotpConfirmData>> => {
    const mutationOptions: UseMutationOptions<TotpConfirmResponse, TotpConfirmError, Options<TotpConfirmData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await totpConfirm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Turn TOTP off for the signed-in user with a current code
 */
export const totpDisableMutation = (options?: Partial<Options<TotpDisableData>>): UseMutationOptions<TotpDisableResponse, TotpDisableError, Options<TotpDisableData>> => {
    const mutationOptions: UseMutationOptions<TotpDisableResponse, TotpDisableError, Options<TotpDisableData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await totpDisable({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const credentialsListQueryKey = (options?: Options<CredentialsListData>) => createQueryKey('credentialsList', options);

/**
 * List credentials (sessions, API keys, agent tokens) without their secrets
 */
export const credentialsListOptions = (options?: Options<CredentialsListData>) => queryOptions<CredentialsListResponse, CredentialsListError, CredentialsListResponse, ReturnType<typeof credentialsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await credentialsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: credentialsListQueryKey(options)
});

/**
 * Create a personal API key (cdk_) scoped to one project or to registry read
 */
export const credentialsNewMutation = (options?: Partial<Options<CredentialsNewData>>): UseMutationOptions<CredentialsNewResponse, CredentialsNewError, Options<CredentialsNewData>> => {
    const mutationOptions: UseMutationOptions<CredentialsNewResponse, CredentialsNewError, Options<CredentialsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await credentialsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke a credential; requests carrying it are refused from now on (irreversible)
 */
export const credentialsRevokeMutation = (options?: Partial<Options<CredentialsRevokeData>>): UseMutationOptions<CredentialsRevokeResponse, CredentialsRevokeError, Options<CredentialsRevokeData>> => {
    const mutationOptions: UseMutationOptions<CredentialsRevokeResponse, CredentialsRevokeError, Options<CredentialsRevokeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await credentialsRevoke({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const collectionsListQueryKey = (options?: Options<CollectionsListData>) => createQueryKey('collectionsList', options);

/**
 * List registry collections (named series of immutable versions), optionally of one kind or tag
 */
export const collectionsListOptions = (options?: Options<CollectionsListData>) => queryOptions<CollectionsListResponse, CollectionsListError, CollectionsListResponse, ReturnType<typeof collectionsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await collectionsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: collectionsListQueryKey(options)
});

export const collectionsGetQueryKey = (options: Options<CollectionsGetData>) => createQueryKey('collectionsGet', options);

/**
 * Get a registry collection with its versions, newest first
 */
export const collectionsGetOptions = (options: Options<CollectionsGetData>) => queryOptions<CollectionsGetResponse, CollectionsGetError, CollectionsGetResponse, ReturnType<typeof collectionsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await collectionsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: collectionsGetQueryKey(options)
});

export const baseModelsListQueryKey = (options?: Options<BaseModelsListData>) => createQueryKey('baseModelsList', options);

/**
 * List base model versions (Hugging Face repository at a pinned revision, licence, model family)
 */
export const baseModelsListOptions = (options?: Options<BaseModelsListData>) => queryOptions<BaseModelsListResponse, BaseModelsListError, BaseModelsListResponse, ReturnType<typeof baseModelsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await baseModelsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: baseModelsListQueryKey(options)
});

export const baseModelsGetQueryKey = (options: Options<BaseModelsGetData>) => createQueryKey('baseModelsGet', options);

/**
 * Get a base model version with the projects that use it
 */
export const baseModelsGetOptions = (options: Options<BaseModelsGetData>) => queryOptions<BaseModelsGetResponse, BaseModelsGetError, BaseModelsGetResponse, ReturnType<typeof baseModelsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await baseModelsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: baseModelsGetQueryKey(options)
});

export const datasetsListQueryKey = (options?: Options<DatasetsListData>) => createQueryKey('datasetsList', options);

/**
 * List dataset versions (immutable, fingerprinted selections with splits and statistics)
 */
export const datasetsListOptions = (options?: Options<DatasetsListData>) => queryOptions<DatasetsListResponse, DatasetsListError, DatasetsListResponse, ReturnType<typeof datasetsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await datasetsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: datasetsListQueryKey(options)
});

export const datasetsGetQueryKey = (options: Options<DatasetsGetData>) => createQueryKey('datasetsGet', options);

/**
 * Get a dataset version with its splits, statistics and the projects that use it
 */
export const datasetsGetOptions = (options: Options<DatasetsGetData>) => queryOptions<DatasetsGetResponse, DatasetsGetError, DatasetsGetResponse, ReturnType<typeof datasetsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await datasetsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: datasetsGetQueryKey(options)
});

export const templatesListQueryKey = (options?: Options<TemplatesListData>) => createQueryKey('templatesList', options);

/**
 * List template versions (instruction templates, permission presets, skills, pipeline templates, agent config)
 */
export const templatesListOptions = (options?: Options<TemplatesListData>) => queryOptions<TemplatesListResponse, TemplatesListError, TemplatesListResponse, ReturnType<typeof templatesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await templatesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: templatesListQueryKey(options)
});

export const templatesGetQueryKey = (options: Options<TemplatesGetData>) => createQueryKey('templatesGet', options);

/**
 * Get a template version with its files (paths and hashes) and the projects that use it
 */
export const templatesGetOptions = (options: Options<TemplatesGetData>) => queryOptions<TemplatesGetResponse, TemplatesGetError, TemplatesGetResponse, ReturnType<typeof templatesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await templatesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: templatesGetQueryKey(options)
});

/**
 * Adopt a registry version into the project by reference
 */
export const projectsAdoptMutation = (options?: Partial<Options<ProjectsAdoptData>>): UseMutationOptions<ProjectsAdoptResponse, ProjectsAdoptError, Options<ProjectsAdoptData>> => {
    const mutationOptions: UseMutationOptions<ProjectsAdoptResponse, ProjectsAdoptError, Options<ProjectsAdoptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsAdopt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adoptionsListQueryKey = (options: Options<AdoptionsListData>) => createQueryKey('adoptionsList', options);

/**
 * Registry versions the project adopted, with the aliases pointing at each
 */
export const adoptionsListOptions = (options: Options<AdoptionsListData>) => queryOptions<AdoptionsListResponse, AdoptionsListError, AdoptionsListResponse, ReturnType<typeof adoptionsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adoptionsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adoptionsListQueryKey(options)
});

export const aliasesListQueryKey = (options: Options<AliasesListData>) => createQueryKey('aliasesList', options);

/**
 * The project's aliases (train-current, baseline, production, …) and the versions they point at
 */
export const aliasesListOptions = (options: Options<AliasesListData>) => queryOptions<AliasesListResponse, AliasesListError, AliasesListResponse, ReturnType<typeof aliasesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await aliasesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: aliasesListQueryKey(options)
});

export const aliasesGetQueryKey = (options: Options<AliasesGetData>) => createQueryKey('aliasesGet', options);

/**
 * Get one project alias and the version it points at
 */
export const aliasesGetOptions = (options: Options<AliasesGetData>) => queryOptions<AliasesGetResponse, AliasesGetError, AliasesGetResponse, ReturnType<typeof aliasesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await aliasesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: aliasesGetQueryKey(options)
});

/**
 * Point a project alias at an adopted registry version (baseline is gated, production moves only by promotion)
 */
export const aliasesSetMutation = (options?: Partial<Options<AliasesSetData>>): UseMutationOptions<AliasesSetResponse, AliasesSetError, Options<AliasesSetData>> => {
    const mutationOptions: UseMutationOptions<AliasesSetResponse, AliasesSetError, Options<AliasesSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await aliasesSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const computeListQueryKey = (options?: Options<ComputeListData>) => createQueryKey('computeList', options);

/**
 * Hosts and their cards (memory cap per card, allowed job kinds) with health
 */
export const computeListOptions = (options?: Options<ComputeListData>) => queryOptions<ComputeListResponse, ComputeListError, ComputeListResponse, ReturnType<typeof computeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await computeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: computeListQueryKey(options)
});

export const computeGetQueryKey = (options: Options<ComputeGetData>) => createQueryKey('computeGet', options);

/**
 * Get a host and its cards
 */
export const computeGetOptions = (options: Options<ComputeGetData>) => queryOptions<ComputeGetResponse, ComputeGetError, ComputeGetResponse, ReturnType<typeof computeGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await computeGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: computeGetQueryKey(options)
});

/**
 * Change a host's description or a card's name, class, memory, memory cap, allowed job kinds and availability windows
 */
export const computeEditMutation = (options?: Partial<Options<ComputeEditData>>): UseMutationOptions<ComputeEditResponse, ComputeEditError, Options<ComputeEditData>> => {
    const mutationOptions: UseMutationOptions<ComputeEditResponse, ComputeEditError, Options<ComputeEditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await computeEdit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const secretsListQueryKey = (options?: Options<SecretsListData>) => createQueryKey('secretsList', options);

/**
 * Named credentials (name, kind, scope, last use); values are never returned
 */
export const secretsListOptions = (options?: Options<SecretsListData>) => queryOptions<SecretsListResponse, SecretsListError, SecretsListResponse, ReturnType<typeof secretsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await secretsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: secretsListQueryKey(options)
});

/**
 * Store a named credential; the value is write-only and never returned
 */
export const secretsNewMutation = (options?: Partial<Options<SecretsNewData>>): UseMutationOptions<SecretsNewResponse, SecretsNewError, Options<SecretsNewData>> => {
    const mutationOptions: UseMutationOptions<SecretsNewResponse, SecretsNewError, Options<SecretsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await secretsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const defaultsGetQueryKey = (options?: Options<DefaultsGetData>) => createQueryKey('defaultsGet', options);

/**
 * The versioned defaults (defaults.yaml) every form, budget and estimate starts from
 */
export const defaultsGetOptions = (options?: Options<DefaultsGetData>) => queryOptions<DefaultsGetResponse, DefaultsGetError, DefaultsGetResponse, ReturnType<typeof defaultsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await defaultsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: defaultsGetQueryKey(options)
});

export const policiesGetQueryKey = (options?: Options<PoliciesGetData>) => createQueryKey('policiesGet', options);

/**
 * Instance-wide policies (budgets now; retention, PII and cache quotas later)
 */
export const policiesGetOptions = (options?: Options<PoliciesGetData>) => queryOptions<PoliciesGetResponse, PoliciesGetError, PoliciesGetResponse, ReturnType<typeof policiesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await policiesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: policiesGetQueryKey(options)
});

/**
 * Change instance-wide policies; values must stay inside the ranges in defaults.yaml
 */
export const policiesEditMutation = (options?: Partial<Options<PoliciesEditData>>): UseMutationOptions<PoliciesEditResponse, PoliciesEditError, Options<PoliciesEditData>> => {
    const mutationOptions: UseMutationOptions<PoliciesEditResponse, PoliciesEditError, Options<PoliciesEditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await policiesEdit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const approvalsListQueryKey = (options?: Options<ApprovalsListData>) => createQueryKey('approvalsList', options);

/**
 * Approvals, pending first, then the most recently decided
 */
export const approvalsListOptions = (options?: Options<ApprovalsListData>) => queryOptions<ApprovalsListResponse, ApprovalsListError, ApprovalsListResponse, ReturnType<typeof approvalsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await approvalsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: approvalsListQueryKey(options)
});

export const approvalsGetQueryKey = (options: Options<ApprovalsGetData>) => createQueryKey('approvalsGet', options);

/**
 * Get an approval with its stored request and, once approved, the replay's result
 */
export const approvalsGetOptions = (options: Options<ApprovalsGetData>) => queryOptions<ApprovalsGetResponse, ApprovalsGetError, ApprovalsGetResponse, ReturnType<typeof approvalsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await approvalsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: approvalsGetQueryKey(options)
});

/**
 * Approve a pending request; the stored request runs as its original actor
 */
export const approvalsApproveMutation = (options?: Partial<Options<ApprovalsApproveData>>): UseMutationOptions<ApprovalsApproveResponse, ApprovalsApproveError, Options<ApprovalsApproveData>> => {
    const mutationOptions: UseMutationOptions<ApprovalsApproveResponse, ApprovalsApproveError, Options<ApprovalsApproveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await approvalsApprove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deny a pending request; it never runs
 */
export const approvalsDenyMutation = (options?: Partial<Options<ApprovalsDenyData>>): UseMutationOptions<ApprovalsDenyResponse, ApprovalsDenyError, Options<ApprovalsDenyData>> => {
    const mutationOptions: UseMutationOptions<ApprovalsDenyResponse, ApprovalsDenyError, Options<ApprovalsDenyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await approvalsDeny({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const auditListQueryKey = (options?: Options<AuditListData>) => createQueryKey('auditList', options);

/**
 * The audit log, newest first — every command, denial and failed attempt with its actor and cause
 */
export const auditListOptions = (options?: Options<AuditListData>) => queryOptions<AuditListResponse, AuditListError, AuditListResponse, ReturnType<typeof auditListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await auditList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: auditListQueryKey(options)
});

export const auditListInfiniteQueryKey = (options?: Options<AuditListData>): QueryKey<Options<AuditListData>> => createQueryKey('auditList', options, true);

/**
 * The audit log, newest first — every command, denial and failed attempt with its actor and cause
 */
export const auditListInfiniteOptions = (options?: Options<AuditListData>) => {
    const opts = infiniteQueryOptions<AuditListResponse, AuditListError, InfiniteData<AuditListResponse>, QueryKey<Options<AuditListData>>, string | Pick<QueryKey<Options<AuditListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AuditListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    before: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await auditList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: auditListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const jobsListQueryKey = (options: Options<JobsListData>) => createQueryKey('jobsList', options);

/**
 * Jobs of a project, newest first
 */
export const jobsListOptions = (options: Options<JobsListData>) => queryOptions<JobsListResponse, JobsListError, JobsListResponse, ReturnType<typeof jobsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await jobsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: jobsListQueryKey(options)
});

export const jobsGetQueryKey = (options: Options<JobsGetData>) => createQueryKey('jobsGet', options);

/**
 * Get a job
 */
export const jobsGetOptions = (options: Options<JobsGetData>) => queryOptions<JobsGetResponse, JobsGetError, JobsGetResponse, ReturnType<typeof jobsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await jobsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: jobsGetQueryKey(options)
});

/**
 * Change a step job's priority (higher starts first; the Queue's reorder)
 */
export const jobsEditMutation = (options?: Partial<Options<JobsEditData>>): UseMutationOptions<JobsEditResponse, JobsEditError, Options<JobsEditData>> => {
    const mutationOptions: UseMutationOptions<JobsEditResponse, JobsEditError, Options<JobsEditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await jobsEdit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel a job; a queued job stops at once, a running one when its handler notices
 */
export const jobsCancelMutation = (options?: Partial<Options<JobsCancelData>>): UseMutationOptions<JobsCancelResponse, JobsCancelError, Options<JobsCancelData>> => {
    const mutationOptions: UseMutationOptions<JobsCancelResponse, JobsCancelError, Options<JobsCancelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await jobsCancel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const jobsWaitQueryKey = (options: Options<JobsWaitData>) => createQueryKey('jobsWait', options);

/**
 * Wait until a job ends or the timeout passes, then return it (agents)
 */
export const jobsWaitOptions = (options: Options<JobsWaitData>) => queryOptions<JobsWaitResponse, JobsWaitError, JobsWaitResponse, ReturnType<typeof jobsWaitQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await jobsWait({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: jobsWaitQueryKey(options)
});

/**
 * Append a dated learning to the project's NOTES.md and commit it to main
 */
export const projectsNoteMutation = (options?: Partial<Options<ProjectsNoteData>>): UseMutationOptions<ProjectsNoteResponse, ProjectsNoteError, Options<ProjectsNoteData>> => {
    const mutationOptions: UseMutationOptions<ProjectsNoteResponse, ProjectsNoteError, Options<ProjectsNoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Diff the project against Cadence's current templates and skills and offer the update as a draft branch
 */
export const projectsSyncMutation = (options?: Partial<Options<ProjectsSyncData>>): UseMutationOptions<ProjectsSyncResponse, ProjectsSyncError, Options<ProjectsSyncData>> => {
    const mutationOptions: UseMutationOptions<ProjectsSyncResponse, ProjectsSyncError, Options<ProjectsSyncData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsSync({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const agentProfileGetQueryKey = (options: Options<AgentProfileGetData>) => createQueryKey('agentProfileGet', options);

/**
 * The project's agent profile with the config files rendered from it
 */
export const agentProfileGetOptions = (options: Options<AgentProfileGetData>) => queryOptions<AgentProfileGetResponse, AgentProfileGetError, AgentProfileGetResponse, ReturnType<typeof agentProfileGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await agentProfileGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: agentProfileGetQueryKey(options)
});

/**
 * Change the agent profile; the rendered config files and AGENTS.md are committed to main
 */
export const agentProfileEditMutation = (options?: Partial<Options<AgentProfileEditData>>): UseMutationOptions<AgentProfileEditResponse, AgentProfileEditError, Options<AgentProfileEditData>> => {
    const mutationOptions: UseMutationOptions<AgentProfileEditResponse, AgentProfileEditError, Options<AgentProfileEditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await agentProfileEdit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const agentModelsListQueryKey = (options?: Options<AgentModelsListData>) => createQueryKey('agentModelsList', options);

/**
 * Agent models per driver, with the default the wizard picks
 */
export const agentModelsListOptions = (options?: Options<AgentModelsListData>) => queryOptions<AgentModelsListResponse, AgentModelsListError, AgentModelsListResponse, ReturnType<typeof agentModelsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await agentModelsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: agentModelsListQueryKey(options)
});

export const recipesListQueryKey = (options: Options<RecipesListData>) => createQueryKey('recipesList', options);

/**
 * Files of the project repository at a branch or commit
 */
export const recipesListOptions = (options: Options<RecipesListData>) => queryOptions<RecipesListResponse, RecipesListError, RecipesListResponse, ReturnType<typeof recipesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await recipesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: recipesListQueryKey(options)
});

/**
 * Create one text file in the project repository and commit it to main
 */
export const recipesNewMutation = (options?: Partial<Options<RecipesNewData>>): UseMutationOptions<RecipesNewResponse, RecipesNewError, Options<RecipesNewData>> => {
    const mutationOptions: UseMutationOptions<RecipesNewResponse, RecipesNewError, Options<RecipesNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recipesNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const recipesGetQueryKey = (options: Options<RecipesGetData>) => createQueryKey('recipesGet', options);

/**
 * One file of the project repository at a branch or commit, with its commit history
 */
export const recipesGetOptions = (options: Options<RecipesGetData>) => queryOptions<RecipesGetResponse, RecipesGetError, RecipesGetResponse, ReturnType<typeof recipesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await recipesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: recipesGetQueryKey(options)
});

/**
 * Write one text file of the project repository and commit it to main (the Recipe document's edits)
 */
export const recipesEditMutation = (options?: Partial<Options<RecipesEditData>>): UseMutationOptions<RecipesEditResponse, RecipesEditError, Options<RecipesEditData>> => {
    const mutationOptions: UseMutationOptions<RecipesEditResponse, RecipesEditError, Options<RecipesEditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recipesEdit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const branchesListQueryKey = (options: Options<BranchesListData>) => createQueryKey('branchesList', options);

/**
 * Open branches of the project repository (session and sync branches not merged into main)
 */
export const branchesListOptions = (options: Options<BranchesListData>) => queryOptions<BranchesListResponse, BranchesListError, BranchesListResponse, ReturnType<typeof branchesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await branchesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: branchesListQueryKey(options)
});

export const branchesGetQueryKey = (options: Options<BranchesGetData>) => createQueryKey('branchesGet', options);

/**
 * A branch with its diff against main and the conflicts a merge would meet
 */
export const branchesGetOptions = (options: Options<BranchesGetData>) => queryOptions<BranchesGetResponse, BranchesGetError, BranchesGetResponse, ReturnType<typeof branchesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await branchesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: branchesGetQueryKey(options)
});

export const branchesCompareQueryKey = (options: Options<BranchesCompareData>) => createQueryKey('branchesCompare', options);

/**
 * A branch compared with main file by file in three ways (merge base, main, branch), with conflict hunks
 */
export const branchesCompareOptions = (options: Options<BranchesCompareData>) => queryOptions<BranchesCompareResponse, BranchesCompareError, BranchesCompareResponse, ReturnType<typeof branchesCompareQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await branchesCompare({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: branchesCompareQueryKey(options)
});

/**
 * Merge a sync branch into main (fast-forward when possible, otherwise a merge commit)
 */
export const branchesAcceptMutation = (options?: Partial<Options<BranchesAcceptData>>): UseMutationOptions<BranchesAcceptResponse, BranchesAcceptError, Options<BranchesAcceptData>> => {
    const mutationOptions: UseMutationOptions<BranchesAcceptResponse, BranchesAcceptError, Options<BranchesAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await branchesAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Discard a sync branch without merging it
 */
export const branchesRevertMutation = (options?: Partial<Options<BranchesRevertData>>): UseMutationOptions<BranchesRevertResponse, BranchesRevertError, Options<BranchesRevertData>> => {
    const mutationOptions: UseMutationOptions<BranchesRevertResponse, BranchesRevertError, Options<BranchesRevertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await branchesRevert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const projectsSearchQueryKey = (options: Options<ProjectsSearchData>) => createQueryKey('projectsSearch', options);

/**
 * Search entities of this project and the registry with free text and qualifiers
 */
export const projectsSearchOptions = (options: Options<ProjectsSearchData>) => queryOptions<ProjectsSearchResponse, ProjectsSearchError, ProjectsSearchResponse, ReturnType<typeof projectsSearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await projectsSearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: projectsSearchQueryKey(options)
});

export const viewsListQueryKey = (options: Options<ViewsListData>) => createQueryKey('viewsList', options);

/**
 * The user's saved searches in a project, by name
 */
export const viewsListOptions = (options: Options<ViewsListData>) => queryOptions<ViewsListResponse, ViewsListError, ViewsListResponse, ReturnType<typeof viewsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await viewsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: viewsListQueryKey(options)
});

export const viewsGetQueryKey = (options: Options<ViewsGetData>) => createQueryKey('viewsGet', options);

/**
 * Get a saved search
 */
export const viewsGetOptions = (options: Options<ViewsGetData>) => queryOptions<ViewsGetResponse, ViewsGetError, ViewsGetResponse, ReturnType<typeof viewsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await viewsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: viewsGetQueryKey(options)
});

/**
 * Save a search under a name (If-Match; omit it only to create)
 */
export const viewsSetMutation = (options?: Partial<Options<ViewsSetData>>): UseMutationOptions<ViewsSetResponse, ViewsSetError, Options<ViewsSetData>> => {
    const mutationOptions: UseMutationOptions<ViewsSetResponse, ViewsSetError, Options<ViewsSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await viewsSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mixesListQueryKey = (options: Options<MixesListData>) => createQueryKey('mixesList', options);

/**
 * The project's mixes, most recently changed first
 */
export const mixesListOptions = (options: Options<MixesListData>) => queryOptions<MixesListResponse, MixesListError, MixesListResponse, ReturnType<typeof mixesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mixesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mixesListQueryKey(options)
});

/**
 * Save a new mix (groups over dataset versions, weights, temperature, replay share) at revision 1
 */
export const mixesNewMutation = (options?: Partial<Options<MixesNewData>>): UseMutationOptions<MixesNewResponse, MixesNewError, Options<MixesNewData>> => {
    const mutationOptions: UseMutationOptions<MixesNewResponse, MixesNewError, Options<MixesNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mixesNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Hours per language and sampling shares of a mix without saving it (metadata only, no GPU)
 */
export const mixesPreviewMutation = (options?: Partial<Options<MixesPreviewData>>): UseMutationOptions<MixesPreviewResponse, MixesPreviewError, Options<MixesPreviewData>> => {
    const mutationOptions: UseMutationOptions<MixesPreviewResponse, MixesPreviewError, Options<MixesPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mixesPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mixesGetQueryKey = (options: Options<MixesGetData>) => createQueryKey('mixesGet', options);

/**
 * Get a mix at its current revision, with its preview and who is editing it
 */
export const mixesGetOptions = (options: Options<MixesGetData>) => queryOptions<MixesGetResponse, MixesGetError, MixesGetResponse, ReturnType<typeof mixesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mixesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mixesGetQueryKey(options)
});

/**
 * Edit a mix; a person's edit makes a new revision, an agent's lands as a draft when the draft policy says so
 */
export const mixesEditMutation = (options?: Partial<Options<MixesEditData>>): UseMutationOptions<MixesEditResponse, MixesEditError, Options<MixesEditData>> => {
    const mutationOptions: UseMutationOptions<MixesEditResponse, MixesEditError, Options<MixesEditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mixesEdit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const draftsListQueryKey = (options: Options<DraftsListData>) => createQueryKey('draftsList', options);

/**
 * Drafts of one entity (open ones by default), newest first
 */
export const draftsListOptions = (options: Options<DraftsListData>) => queryOptions<DraftsListResponse, DraftsListError, DraftsListResponse, ReturnType<typeof draftsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await draftsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: draftsListQueryKey(options)
});

export const draftsGetQueryKey = (options: Options<DraftsGetData>) => createQueryKey('draftsGet', options);

/**
 * Get a draft with its changes against the revision it was based on
 */
export const draftsGetOptions = (options: Options<DraftsGetData>) => queryOptions<DraftsGetResponse, DraftsGetError, DraftsGetResponse, ReturnType<typeof draftsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await draftsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: draftsGetQueryKey(options)
});

/**
 * Apply a draft as a new revision of its entity, attributed to the person who accepts it
 */
export const draftsAcceptMutation = (options?: Partial<Options<DraftsAcceptData>>): UseMutationOptions<DraftsAcceptResponse, DraftsAcceptError, Options<DraftsAcceptData>> => {
    const mutationOptions: UseMutationOptions<DraftsAcceptResponse, DraftsAcceptError, Options<DraftsAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await draftsAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Discard a draft; its entity stays as it is
 */
export const draftsRevertMutation = (options?: Partial<Options<DraftsRevertData>>): UseMutationOptions<DraftsRevertResponse, DraftsRevertError, Options<DraftsRevertData>> => {
    const mutationOptions: UseMutationOptions<DraftsRevertResponse, DraftsRevertError, Options<DraftsRevertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await draftsRevert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const agentSessionsListQueryKey = (options: Options<AgentSessionsListData>) => createQueryKey('agentSessionsList', options);

/**
 * The project's agent sessions, live ones first, then the most recently changed
 */
export const agentSessionsListOptions = (options: Options<AgentSessionsListData>) => queryOptions<AgentSessionsListResponse, AgentSessionsListError, AgentSessionsListResponse, ReturnType<typeof agentSessionsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await agentSessionsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: agentSessionsListQueryKey(options)
});

/**
 * Start Claude Code or opencode on its own branch session/<id> of the project repository
 */
export const agentSessionsNewMutation = (options?: Partial<Options<AgentSessionsNewData>>): UseMutationOptions<AgentSessionsNewResponse, AgentSessionsNewError, Options<AgentSessionsNewData>> => {
    const mutationOptions: UseMutationOptions<AgentSessionsNewResponse, AgentSessionsNewError, Options<AgentSessionsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await agentSessionsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const agentSessionsGetQueryKey = (options: Options<AgentSessionsGetData>) => createQueryKey('agentSessionsGet', options);

/**
 * Get an agent session with its state, budget and use, branch and merge state
 */
export const agentSessionsGetOptions = (options: Options<AgentSessionsGetData>) => queryOptions<AgentSessionsGetResponse, AgentSessionsGetError, AgentSessionsGetResponse, ReturnType<typeof agentSessionsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await agentSessionsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: agentSessionsGetQueryKey(options)
});

/**
 * Stop the session's current turn; with end, also end the session
 */
export const agentSessionsCancelMutation = (options?: Partial<Options<AgentSessionsCancelData>>): UseMutationOptions<AgentSessionsCancelResponse, AgentSessionsCancelError, Options<AgentSessionsCancelData>> => {
    const mutationOptions: UseMutationOptions<AgentSessionsCancelResponse, AgentSessionsCancelError, Options<AgentSessionsCancelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await agentSessionsCancel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Pause a session; the current turn stops, the worktree is committed and the agent process ends
 */
export const agentSessionsPauseMutation = (options?: Partial<Options<AgentSessionsPauseData>>): UseMutationOptions<AgentSessionsPauseResponse, AgentSessionsPauseError, Options<AgentSessionsPauseData>> => {
    const mutationOptions: UseMutationOptions<AgentSessionsPauseResponse, AgentSessionsPauseError, Options<AgentSessionsPauseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await agentSessionsPause({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resume a paused session (ACP session/resume, else a new ACP session with a transcript summary)
 */
export const agentSessionsResumeMutation = (options?: Partial<Options<AgentSessionsResumeData>>): UseMutationOptions<AgentSessionsResumeResponse, AgentSessionsResumeError, Options<AgentSessionsResumeData>> => {
    const mutationOptions: UseMutationOptions<AgentSessionsResumeResponse, AgentSessionsResumeError, Options<AgentSessionsResumeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await agentSessionsResume({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Merge the session branch into main as a whole and end the session
 */
export const agentSessionsAcceptMutation = (options?: Partial<Options<AgentSessionsAcceptData>>): UseMutationOptions<AgentSessionsAcceptResponse, AgentSessionsAcceptError, Options<AgentSessionsAcceptData>> => {
    const mutationOptions: UseMutationOptions<AgentSessionsAcceptResponse, AgentSessionsAcceptError, Options<AgentSessionsAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await agentSessionsAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Discard the session branch as a whole and end the session
 */
export const agentSessionsRevertMutation = (options?: Partial<Options<AgentSessionsRevertData>>): UseMutationOptions<AgentSessionsRevertResponse, AgentSessionsRevertError, Options<AgentSessionsRevertData>> => {
    const mutationOptions: UseMutationOptions<AgentSessionsRevertResponse, AgentSessionsRevertError, Options<AgentSessionsRevertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await agentSessionsRevert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const agentMessagesListQueryKey = (options: Options<AgentMessagesListData>) => createQueryKey('agentMessagesList', options);

/**
 * The session transcript in order, one page after a sequence number
 */
export const agentMessagesListOptions = (options: Options<AgentMessagesListData>) => queryOptions<AgentMessagesListResponse, AgentMessagesListError, AgentMessagesListResponse, ReturnType<typeof agentMessagesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await agentMessagesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: agentMessagesListQueryKey(options)
});

export const agentMessagesListInfiniteQueryKey = (options: Options<AgentMessagesListData>): QueryKey<Options<AgentMessagesListData>> => createQueryKey('agentMessagesList', options, true);

/**
 * The session transcript in order, one page after a sequence number
 */
export const agentMessagesListInfiniteOptions = (options: Options<AgentMessagesListData>) => {
    const opts = infiniteQueryOptions<AgentMessagesListResponse, AgentMessagesListError, InfiniteData<AgentMessagesListResponse>, QueryKey<Options<AgentMessagesListData>>, number | Pick<QueryKey<Options<AgentMessagesListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AgentMessagesListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await agentMessagesList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: agentMessagesListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Send a user message with entity references; the agent answers on agent.session.{id}
 */
export const agentMessagesNewMutation = (options?: Partial<Options<AgentMessagesNewData>>): UseMutationOptions<AgentMessagesNewResponse, AgentMessagesNewError, Options<AgentMessagesNewData>> => {
    const mutationOptions: UseMutationOptions<AgentMessagesNewResponse, AgentMessagesNewError, Options<AgentMessagesNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await agentMessagesNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Long-poll for work — sessions to start, messages to deliver, controls and permission decisions
 */
export const hostSessionsClaimMutation = (options?: Partial<Options<HostSessionsClaimData>>): UseMutationOptions<HostSessionsClaimResponse, HostSessionsClaimError, Options<HostSessionsClaimData>> => {
    const mutationOptions: UseMutationOptions<HostSessionsClaimResponse, HostSessionsClaimError, Options<HostSessionsClaimData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hostSessionsClaim({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Post a batch of transcript entries, the session state, usage and the ACP session id
 */
export const hostSessionsReportMutation = (options?: Partial<Options<HostSessionsReportData>>): UseMutationOptions<HostSessionsReportResponse, HostSessionsReportError, Options<HostSessionsReportData>> => {
    const mutationOptions: UseMutationOptions<HostSessionsReportResponse, HostSessionsReportError, Options<HostSessionsReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hostSessionsReport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Raise an ACP permission request; the preset answers it or it becomes an agent-permission approval
 */
export const hostSessionsAskMutation = (options?: Partial<Options<HostSessionsAskData>>): UseMutationOptions<HostSessionsAskResponse, HostSessionsAskError, Options<HostSessionsAskData>> => {
    const mutationOptions: UseMutationOptions<HostSessionsAskResponse, HostSessionsAskError, Options<HostSessionsAskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hostSessionsAsk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const hostSessionsDecisionQueryKey = (options: Options<HostSessionsDecisionData>) => createQueryKey('hostSessionsDecision', options);

/**
 * Read (or wait for) the decision on an agent-permission approval
 */
export const hostSessionsDecisionOptions = (options: Options<HostSessionsDecisionData>) => queryOptions<HostSessionsDecisionResponse, HostSessionsDecisionError, HostSessionsDecisionResponse, ReturnType<typeof hostSessionsDecisionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hostSessionsDecision({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hostSessionsDecisionQueryKey(options)
});

export const agentCredentialsListQueryKey = (options?: Options<AgentCredentialsListData>) => createQueryKey('agentCredentialsList', options);

/**
 * The agents' model accounts (metadata only), whether an agent host is connected, and opencode's default model
 */
export const agentCredentialsListOptions = (options?: Options<AgentCredentialsListData>) => queryOptions<AgentCredentialsListResponse, AgentCredentialsListError, AgentCredentialsListResponse, ReturnType<typeof agentCredentialsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await agentCredentialsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: agentCredentialsListQueryKey(options)
});

export const agentCredentialsGetQueryKey = (options: Options<AgentCredentialsGetData>) => createQueryKey('agentCredentialsGet', options);

/**
 * One agent credential's metadata (never its value)
 */
export const agentCredentialsGetOptions = (options: Options<AgentCredentialsGetData>) => queryOptions<AgentCredentialsGetResponse, AgentCredentialsGetError, AgentCredentialsGetResponse, ReturnType<typeof agentCredentialsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await agentCredentialsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: agentCredentialsGetQueryKey(options)
});

/**
 * Connect or change an agent's model account (write-only value) or choose opencode's default model
 */
export const agentCredentialsSetMutation = (options?: Partial<Options<AgentCredentialsSetData>>): UseMutationOptions<AgentCredentialsSetResponse, AgentCredentialsSetError, Options<AgentCredentialsSetData>> => {
    const mutationOptions: UseMutationOptions<AgentCredentialsSetResponse, AgentCredentialsSetError, Options<AgentCredentialsSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await agentCredentialsSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ask the agent host for a tiny real request through the agent (and opencode's model list); the result arrives as an event
 */
export const agentCredentialsVerifyMutation = (options?: Partial<Options<AgentCredentialsVerifyData>>): UseMutationOptions<AgentCredentialsVerifyResponse, AgentCredentialsVerifyError, Options<AgentCredentialsVerifyData>> => {
    const mutationOptions: UseMutationOptions<AgentCredentialsVerifyResponse, AgentCredentialsVerifyError, Options<AgentCredentialsVerifyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await agentCredentialsVerify({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Disconnect an agent's model account; the agent host removes it from the agent-credentials volume
 */
export const agentCredentialsArchiveMutation = (options?: Partial<Options<AgentCredentialsArchiveData>>): UseMutationOptions<AgentCredentialsArchiveResponse, AgentCredentialsArchiveError, Options<AgentCredentialsArchiveData>> => {
    const mutationOptions: UseMutationOptions<AgentCredentialsArchiveResponse, AgentCredentialsArchiveError, Options<AgentCredentialsArchiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await agentCredentialsArchive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const agentProvidersListQueryKey = (options?: Options<AgentProvidersListData>) => createQueryKey('agentProvidersList', options);

/**
 * The provider catalogue the Agents settings choose from (Claude subscription; opencode providers and their API hosts)
 */
export const agentProvidersListOptions = (options?: Options<AgentProvidersListData>) => queryOptions<AgentProvidersListResponse, AgentProvidersListError, AgentProvidersListResponse, ReturnType<typeof agentProvidersListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await agentProvidersList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: agentProvidersListQueryKey(options)
});

/**
 * Long-poll for agent credential tasks — values to write into the agent-credentials volume, removals, verifications
 */
export const hostCredentialsClaimMutation = (options?: Partial<Options<HostCredentialsClaimData>>): UseMutationOptions<HostCredentialsClaimResponse, HostCredentialsClaimError, Options<HostCredentialsClaimData>> => {
    const mutationOptions: UseMutationOptions<HostCredentialsClaimResponse, HostCredentialsClaimError, Options<HostCredentialsClaimData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hostCredentialsClaim({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Acknowledge an agent credential task with its outcome (written, removed, verified with the model list)
 */
export const hostCredentialsReportMutation = (options?: Partial<Options<HostCredentialsReportData>>): UseMutationOptions<HostCredentialsReportResponse, HostCredentialsReportError, Options<HostCredentialsReportData>> => {
    const mutationOptions: UseMutationOptions<HostCredentialsReportResponse, HostCredentialsReportError, Options<HostCredentialsReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hostCredentialsReport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const egressHostsListQueryKey = (options?: Options<EgressHostsListData>) => createQueryKey('egressHostsList', options);

/**
 * The hosts the agent sandbox may reach beyond the proxy's static list (configured providers, custom base URLs)
 */
export const egressHostsListOptions = (options?: Options<EgressHostsListData>) => queryOptions<EgressHostsListResponse, EgressHostsListError, EgressHostsListResponse, ReturnType<typeof egressHostsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await egressHostsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: egressHostsListQueryKey(options)
});

/**
 * Give back every live session of a host that is shutting down, so the next host takes them at once
 *
 * The host stops its agents first (their last turn is committed and reported), then releases. Each session loses its host and token, a turn in progress counts as interrupted (the next host tells the agent, and its pending permission requests are withdrawn as interrupted, not declined), messages the host took but never gave the agent go back to pending, and the Chat shows the session as reconnecting until a host claims it.
 *
 */
export const hostSessionsReleaseMutation = (options?: Partial<Options<HostSessionsReleaseData>>): UseMutationOptions<HostSessionsReleaseResponse, HostSessionsReleaseError, Options<HostSessionsReleaseData>> => {
    const mutationOptions: UseMutationOptions<HostSessionsReleaseResponse, HostSessionsReleaseError, Options<HostSessionsReleaseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hostSessionsRelease({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Publish the worker's runtime, step kinds and model families at start; answers the worker id
 */
export const workerRegistrationsNewMutation = (options?: Partial<Options<WorkerRegistrationsNewData>>): UseMutationOptions<WorkerRegistrationsNewResponse, WorkerRegistrationsNewError, Options<WorkerRegistrationsNewData>> => {
    const mutationOptions: UseMutationOptions<WorkerRegistrationsNewResponse, WorkerRegistrationsNewError, Options<WorkerRegistrationsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await workerRegistrationsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Long-poll for a step to run on one of this worker's cards
 */
export const workerLeasesClaimMutation = (options?: Partial<Options<WorkerLeasesClaimData>>): UseMutationOptions<WorkerLeasesClaimResponse, WorkerLeasesClaimError, Options<WorkerLeasesClaimData>> => {
    const mutationOptions: UseMutationOptions<WorkerLeasesClaimResponse, WorkerLeasesClaimError, Options<WorkerLeasesClaimData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await workerLeasesClaim({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Heartbeat with progress and card telemetry; three missed beats reap the lease
 */
export const workerLeasesReportMutation = (options?: Partial<Options<WorkerLeasesReportData>>): UseMutationOptions<WorkerLeasesReportResponse, WorkerLeasesReportError, Options<WorkerLeasesReportData>> => {
    const mutationOptions: UseMutationOptions<WorkerLeasesReportResponse, WorkerLeasesReportError, Options<WorkerLeasesReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await workerLeasesReport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Append NDJSON log lines to the job's log; they stream on job.{id}.log
 */
export const workerLogsNewMutation = (options?: Partial<Options<WorkerLogsNewData>>): UseMutationOptions<WorkerLogsNewResponse, WorkerLogsNewError, Options<WorkerLogsNewData>> => {
    const mutationOptions: UseMutationOptions<WorkerLogsNewResponse, WorkerLogsNewError, Options<WorkerLogsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await workerLogsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Append a batch of metric points (loss, validation WER, LR, throughput, card memory)
 */
export const workerMetricsNewMutation = (options?: Partial<Options<WorkerMetricsNewData>>): UseMutationOptions<WorkerMetricsNewResponse, WorkerMetricsNewError, Options<WorkerMetricsNewData>> => {
    const mutationOptions: UseMutationOptions<WorkerMetricsNewResponse, WorkerMetricsNewError, Options<WorkerMetricsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await workerMetricsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Publish an intermediate output of a running step (a validation checkpoint); recorded and hooked at once
 *
 * The artifact must already be in the content store and name one of the step's outputs with its declared type. The control plane records it and runs the output hooks of its type in their own transaction (a `checkpoint` registers on the run and re-ranks its top k), so outputs published during a lease survive a pause, a window close or a failure. Publishing the same hash again is a no-op. The release still sends the step's final outputs.
 *
 */
export const workerOutputsNewMutation = (options?: Partial<Options<WorkerOutputsNewData>>): UseMutationOptions<WorkerOutputsNewResponse, WorkerOutputsNewError, Options<WorkerOutputsNewData>> => {
    const mutationOptions: UseMutationOptions<WorkerOutputsNewResponse, WorkerOutputsNewError, Options<WorkerOutputsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await workerOutputsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Complete a lease with the step's outcome, its output artifacts and final metrics, or a typed error
 */
export const workerLeasesReleaseMutation = (options?: Partial<Options<WorkerLeasesReleaseData>>): UseMutationOptions<WorkerLeasesReleaseResponse, WorkerLeasesReleaseError, Options<WorkerLeasesReleaseData>> => {
    const mutationOptions: UseMutationOptions<WorkerLeasesReleaseResponse, WorkerLeasesReleaseError, Options<WorkerLeasesReleaseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await workerLeasesRelease({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload a blob into the content store (workers without the shared volume); the hash is verified
 */
export const workerArtifactsSetMutation = (options?: Partial<Options<WorkerArtifactsSetData>>): UseMutationOptions<WorkerArtifactsSetResponse, WorkerArtifactsSetError, Options<WorkerArtifactsSetData>> => {
    const mutationOptions: UseMutationOptions<WorkerArtifactsSetResponse, WorkerArtifactsSetError, Options<WorkerArtifactsSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await workerArtifactsSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const runtimesListQueryKey = (options?: Options<RuntimesListData>) => createQueryKey('runtimesList', options);

/**
 * List runtime versions (container image pinned by digest, environment lock, worker plugin) published by workers
 */
export const runtimesListOptions = (options?: Options<RuntimesListData>) => queryOptions<RuntimesListResponse, RuntimesListError, RuntimesListResponse, ReturnType<typeof runtimesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await runtimesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: runtimesListQueryKey(options)
});

export const runtimesGetQueryKey = (options: Options<RuntimesGetData>) => createQueryKey('runtimesGet', options);

/**
 * Get a runtime version with the workers that run it
 */
export const runtimesGetOptions = (options: Options<RuntimesGetData>) => queryOptions<RuntimesGetResponse, RuntimesGetError, RuntimesGetResponse, ReturnType<typeof runtimesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await runtimesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: runtimesGetQueryKey(options)
});

export const modelFamiliesListQueryKey = (options?: Options<ModelFamiliesListData>) => createQueryKey('modelFamiliesList', options);

/**
 * List model family versions (architecture, capabilities, latency profiles, role step kinds) published by runtimes
 */
export const modelFamiliesListOptions = (options?: Options<ModelFamiliesListData>) => queryOptions<ModelFamiliesListResponse, ModelFamiliesListError, ModelFamiliesListResponse, ReturnType<typeof modelFamiliesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await modelFamiliesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: modelFamiliesListQueryKey(options)
});

export const modelFamiliesGetQueryKey = (options: Options<ModelFamiliesGetData>) => createQueryKey('modelFamiliesGet', options);

/**
 * Get a model family version
 */
export const modelFamiliesGetOptions = (options: Options<ModelFamiliesGetData>) => queryOptions<ModelFamiliesGetResponse, ModelFamiliesGetError, ModelFamiliesGetResponse, ReturnType<typeof modelFamiliesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await modelFamiliesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: modelFamiliesGetQueryKey(options)
});

export const stepKindsListQueryKey = (options?: Options<StepKindsListData>) => createQueryKey('stepKindsList', options);

/**
 * List step kind versions (parameter schema with defaults, inputs, outputs, resources, runtime)
 */
export const stepKindsListOptions = (options?: Options<StepKindsListData>) => queryOptions<StepKindsListResponse, StepKindsListError, StepKindsListResponse, ReturnType<typeof stepKindsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await stepKindsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: stepKindsListQueryKey(options)
});

export const stepKindsGetQueryKey = (options: Options<StepKindsGetData>) => createQueryKey('stepKindsGet', options);

/**
 * Get a step kind version
 */
export const stepKindsGetOptions = (options: Options<StepKindsGetData>) => queryOptions<StepKindsGetResponse, StepKindsGetError, StepKindsGetResponse, ReturnType<typeof stepKindsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await stepKindsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: stepKindsGetQueryKey(options)
});

/**
 * Pause a step job; a queued one is held back, a running one saves its state and returns to the queue
 */
export const jobsPauseMutation = (options?: Partial<Options<JobsPauseData>>): UseMutationOptions<JobsPauseResponse, JobsPauseError, Options<JobsPauseData>> => {
    const mutationOptions: UseMutationOptions<JobsPauseResponse, JobsPauseError, Options<JobsPauseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await jobsPause({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resume a paused step job; it waits in the queue for a free card (from its saved training state)
 */
export const jobsResumeMutation = (options?: Partial<Options<JobsResumeData>>): UseMutationOptions<JobsResumeResponse, JobsResumeError, Options<JobsResumeData>> => {
    const mutationOptions: UseMutationOptions<JobsResumeResponse, JobsResumeError, Options<JobsResumeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await jobsResume({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const jobLogsListQueryKey = (options: Options<JobLogsListData>) => createQueryKey('jobLogsList', options);

/**
 * Read a job's log lines from its worker, filtered by level and text, after a line number
 */
export const jobLogsListOptions = (options: Options<JobLogsListData>) => queryOptions<JobLogsListResponse, JobLogsListError, JobLogsListResponse, ReturnType<typeof jobLogsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await jobLogsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: jobLogsListQueryKey(options)
});

export const jobLogsListInfiniteQueryKey = (options: Options<JobLogsListData>): QueryKey<Options<JobLogsListData>> => createQueryKey('jobLogsList', options, true);

/**
 * Read a job's log lines from its worker, filtered by level and text, after a line number
 */
export const jobLogsListInfiniteOptions = (options: Options<JobLogsListData>) => {
    const opts = infiniteQueryOptions<JobLogsListResponse, JobLogsListError, InfiniteData<JobLogsListResponse>, QueryKey<Options<JobLogsListData>>, number | Pick<QueryKey<Options<JobLogsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<JobLogsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await jobLogsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: jobLogsListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const queueEntriesListQueryKey = (options?: Options<QueueEntriesListData>) => createQueryKey('queueEntriesList', options);

/**
 * The step queue across projects — waiting, paused and running step jobs with their card and lease
 */
export const queueEntriesListOptions = (options?: Options<QueueEntriesListData>) => queryOptions<QueueEntriesListResponse, QueueEntriesListError, QueueEntriesListResponse, ReturnType<typeof queueEntriesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await queueEntriesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: queueEntriesListQueryKey(options)
});

export const artifactsGetQueryKey = (options: Options<ArtifactsGetData>) => createQueryKey('artifactsGet', options);

/**
 * Get an artifact by hash — type, size, metadata, producing step, a directory's files, and small content
 */
export const artifactsGetOptions = (options: Options<ArtifactsGetData>) => queryOptions<ArtifactsGetResponse, ArtifactsGetError, ArtifactsGetResponse, ReturnType<typeof artifactsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await artifactsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: artifactsGetQueryKey(options)
});

export const pipelinesListQueryKey = (options: Options<PipelinesListData>) => createQueryKey('pipelinesList', options);

/**
 * The project's pipelines (pipelines*.yaml at a ref) and the bundled templates it does not override
 */
export const pipelinesListOptions = (options: Options<PipelinesListData>) => queryOptions<PipelinesListResponse, PipelinesListError, PipelinesListResponse, ReturnType<typeof pipelinesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pipelinesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pipelinesListQueryKey(options)
});

/**
 * Validate a pipeline against the step registry and start a pipeline run (dryRun validates and estimates)
 */
export const pipelinesRunMutation = (options?: Partial<Options<PipelinesRunData>>): UseMutationOptions<PipelinesRunResponse, PipelinesRunError, Options<PipelinesRunData>> => {
    const mutationOptions: UseMutationOptions<PipelinesRunResponse, PipelinesRunError, Options<PipelinesRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pipelinesRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pipelineRunsListQueryKey = (options: Options<PipelineRunsListData>) => createQueryKey('pipelineRunsList', options);

/**
 * Pipeline runs of a project, newest first
 */
export const pipelineRunsListOptions = (options: Options<PipelineRunsListData>) => queryOptions<PipelineRunsListResponse, PipelineRunsListError, PipelineRunsListResponse, ReturnType<typeof pipelineRunsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pipelineRunsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pipelineRunsListQueryKey(options)
});

export const pipelineRunsGetQueryKey = (options: Options<PipelineRunsGetData>) => createQueryKey('pipelineRunsGet', options);

/**
 * Get a pipeline run with the status, inputs, outputs, attempts and departures of every step
 */
export const pipelineRunsGetOptions = (options: Options<PipelineRunsGetData>) => queryOptions<PipelineRunsGetResponse, PipelineRunsGetError, PipelineRunsGetResponse, ReturnType<typeof pipelineRunsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pipelineRunsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pipelineRunsGetQueryKey(options)
});

/**
 * Cancel a pipeline run; waiting steps never start and running step jobs are cancelled
 */
export const pipelineRunsCancelMutation = (options?: Partial<Options<PipelineRunsCancelData>>): UseMutationOptions<PipelineRunsCancelResponse, PipelineRunsCancelError, Options<PipelineRunsCancelData>> => {
    const mutationOptions: UseMutationOptions<PipelineRunsCancelResponse, PipelineRunsCancelError, Options<PipelineRunsCancelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pipelineRunsCancel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retry a failed step of a pipeline run as a new attempt; the run continues from there
 */
export const pipelineRunsRetryMutation = (options?: Partial<Options<PipelineRunsRetryData>>): UseMutationOptions<PipelineRunsRetryResponse, PipelineRunsRetryError, Options<PipelineRunsRetryData>> => {
    const mutationOptions: UseMutationOptions<PipelineRunsRetryResponse, PipelineRunsRetryError, Options<PipelineRunsRetryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pipelineRunsRetry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pipelineRunsWaitQueryKey = (options: Options<PipelineRunsWaitData>) => createQueryKey('pipelineRunsWait', options);

/**
 * Wait until a pipeline run ends or the timeout passes, then return it (agents)
 */
export const pipelineRunsWaitOptions = (options: Options<PipelineRunsWaitData>) => queryOptions<PipelineRunsWaitResponse, PipelineRunsWaitError, PipelineRunsWaitResponse, ReturnType<typeof pipelineRunsWaitQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pipelineRunsWait({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pipelineRunsWaitQueryKey(options)
});

export const sourcesListQueryKey = (options?: Options<SourcesListData>) => createQueryKey('sourcesList', options);

/**
 * List sources (corpora with licence, kind and languages; eval-only until cleared for training)
 */
export const sourcesListOptions = (options?: Options<SourcesListData>) => queryOptions<SourcesListResponse, SourcesListError, SourcesListResponse, ReturnType<typeof sourcesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await sourcesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: sourcesListQueryKey(options)
});

/**
 * Register a source (a corpus with its licence, kind and languages) before ingesting it; it starts eval-only
 */
export const sourcesNewMutation = (options?: Partial<Options<SourcesNewData>>): UseMutationOptions<SourcesNewResponse, SourcesNewError, Options<SourcesNewData>> => {
    const mutationOptions: UseMutationOptions<SourcesNewResponse, SourcesNewError, Options<SourcesNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sourcesNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sourcesGetQueryKey = (options: Options<SourcesGetData>) => createQueryKey('sourcesGet', options);

/**
 * Get a source with its utterance count, hours and the dataset versions built from it
 */
export const sourcesGetOptions = (options: Options<SourcesGetData>) => queryOptions<SourcesGetResponse, SourcesGetError, SourcesGetResponse, ReturnType<typeof sourcesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await sourcesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: sourcesGetQueryKey(options)
});

/**
 * Change a source's description or licence, or clear it for training (a person's decision)
 */
export const sourcesEditMutation = (options?: Partial<Options<SourcesEditData>>): UseMutationOptions<SourcesEditResponse, SourcesEditError, Options<SourcesEditData>> => {
    const mutationOptions: UseMutationOptions<SourcesEditResponse, SourcesEditError, Options<SourcesEditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sourcesEdit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive a source (soft); it takes no new imports, its utterances and dataset versions stay
 */
export const sourcesArchiveMutation = (options?: Partial<Options<SourcesArchiveData>>): UseMutationOptions<SourcesArchiveResponse, SourcesArchiveError, Options<SourcesArchiveData>> => {
    const mutationOptions: UseMutationOptions<SourcesArchiveResponse, SourcesArchiveError, Options<SourcesArchiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sourcesArchive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const utterancesListQueryKey = (options?: Options<UtterancesListData>) => createQueryKey('utterancesList', options);

/**
 * A page of utterances (audio segments by content hash) filtered by source, dataset version, split or language
 */
export const utterancesListOptions = (options?: Options<UtterancesListData>) => queryOptions<UtterancesListResponse, UtterancesListError, UtterancesListResponse, ReturnType<typeof utterancesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await utterancesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: utterancesListQueryKey(options)
});

export const utterancesListInfiniteQueryKey = (options?: Options<UtterancesListData>): QueryKey<Options<UtterancesListData>> => createQueryKey('utterancesList', options, true);

/**
 * A page of utterances (audio segments by content hash) filtered by source, dataset version, split or language
 */
export const utterancesListInfiniteOptions = (options?: Options<UtterancesListData>) => {
    const opts = infiniteQueryOptions<UtterancesListResponse, UtterancesListError, InfiniteData<UtterancesListResponse>, QueryKey<Options<UtterancesListData>>, string | Pick<QueryKey<Options<UtterancesListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<UtterancesListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await utterancesList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: utterancesListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const utterancesGetQueryKey = (options: Options<UtterancesGetData>) => createQueryKey('utterancesGet', options);

/**
 * Get an utterance with its transcripts, fingerprints and the dataset versions (and splits) that hold it
 */
export const utterancesGetOptions = (options: Options<UtterancesGetData>) => queryOptions<UtterancesGetResponse, UtterancesGetError, UtterancesGetResponse, ReturnType<typeof utterancesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await utterancesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: utterancesGetQueryKey(options)
});

export const notificationRulesListQueryKey = (options?: Options<NotificationRulesListData>) => createQueryKey('notificationRulesList', options);

/**
 * The notification routing table — one rule per event class with its channels and timing
 */
export const notificationRulesListOptions = (options?: Options<NotificationRulesListData>) => queryOptions<NotificationRulesListResponse, NotificationRulesListError, NotificationRulesListResponse, ReturnType<typeof notificationRulesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await notificationRulesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: notificationRulesListQueryKey(options)
});

/**
 * Change which channels an event class reaches, when, and whether Telegram rings (admin only)
 */
export const notificationRulesEditMutation = (options?: Partial<Options<NotificationRulesEditData>>): UseMutationOptions<NotificationRulesEditResponse, NotificationRulesEditError, Options<NotificationRulesEditData>> => {
    const mutationOptions: UseMutationOptions<NotificationRulesEditResponse, NotificationRulesEditError, Options<NotificationRulesEditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationRulesEdit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const notificationSettingsGetQueryKey = (options?: Options<NotificationSettingsGetData>) => createQueryKey('notificationSettingsGet', options);

/**
 * Quiet hours, the digest time and the Telegram bot's allow-listed chats and status
 */
export const notificationSettingsGetOptions = (options?: Options<NotificationSettingsGetData>) => queryOptions<NotificationSettingsGetResponse, NotificationSettingsGetError, NotificationSettingsGetResponse, ReturnType<typeof notificationSettingsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await notificationSettingsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: notificationSettingsGetQueryKey(options)
});

/**
 * Change quiet hours, the digest time or the allow-listed Telegram chats (admin only)
 */
export const notificationSettingsEditMutation = (options?: Partial<Options<NotificationSettingsEditData>>): UseMutationOptions<NotificationSettingsEditResponse, NotificationSettingsEditError, Options<NotificationSettingsEditData>> => {
    const mutationOptions: UseMutationOptions<NotificationSettingsEditResponse, NotificationSettingsEditError, Options<NotificationSettingsEditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await notificationSettingsEdit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Store or replace the Telegram bot token (write-only, kept in the secret store as telegram-bot-token)
 */
export const telegramBotSetMutation = (options?: Partial<Options<TelegramBotSetData>>): UseMutationOptions<TelegramBotSetResponse, TelegramBotSetError, Options<TelegramBotSetData>> => {
    const mutationOptions: UseMutationOptions<TelegramBotSetResponse, TelegramBotSetError, Options<TelegramBotSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await telegramBotSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check the bot token with Telegram and send a test message to every allow-listed chat
 */
export const telegramBotVerifyMutation = (options?: Partial<Options<TelegramBotVerifyData>>): UseMutationOptions<TelegramBotVerifyResponse, TelegramBotVerifyError, Options<TelegramBotVerifyData>> => {
    const mutationOptions: UseMutationOptions<TelegramBotVerifyResponse, TelegramBotVerifyError, Options<TelegramBotVerifyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await telegramBotVerify({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const backupsListQueryKey = (options?: Options<BackupsListData>) => createQueryKey('backupsList', options);

/**
 * Backup sets, newest first, with the schedule and the last restore test
 */
export const backupsListOptions = (options?: Options<BackupsListData>) => queryOptions<BackupsListResponse, BackupsListError, BackupsListResponse, ReturnType<typeof backupsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await backupsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: backupsListQueryKey(options)
});

/**
 * Take a backup set now (pg_dump plus the content store); answers the job
 */
export const backupsNewMutation = (options?: Partial<Options<BackupsNewData>>): UseMutationOptions<BackupsNewResponse, BackupsNewError, Options<BackupsNewData>> => {
    const mutationOptions: UseMutationOptions<BackupsNewResponse, BackupsNewError, Options<BackupsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await backupsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const backupsGetQueryKey = (options: Options<BackupsGetData>) => createQueryKey('backupsGet', options);

/**
 * Get a backup set with its manifest and last restore test report
 */
export const backupsGetOptions = (options: Options<BackupsGetData>) => queryOptions<BackupsGetResponse, BackupsGetError, BackupsGetResponse, ReturnType<typeof backupsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await backupsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: backupsGetQueryKey(options)
});

/**
 * Restore the set into a scratch database and check it (the weekly restore test, now); answers the job
 */
export const backupsVerifyMutation = (options?: Partial<Options<BackupsVerifyData>>): UseMutationOptions<BackupsVerifyResponse, BackupsVerifyError, Options<BackupsVerifyData>> => {
    const mutationOptions: UseMutationOptions<BackupsVerifyResponse, BackupsVerifyError, Options<BackupsVerifyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await backupsVerify({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const runsListQueryKey = (options: Options<RunsListData>) => createQueryKey('runsList', options);

/**
 * Training runs of a project, newest first
 */
export const runsListOptions = (options: Options<RunsListData>) => queryOptions<RunsListResponse, RunsListError, RunsListResponse, ReturnType<typeof runsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await runsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: runsListQueryKey(options)
});

/**
 * Start a training run (one optimisation stage); ?dryRun=true answers the estimate first
 */
export const runsNewMutation = (options?: Partial<Options<RunsNewData>>): UseMutationOptions<RunsNewResponse, RunsNewError, Options<RunsNewData>> => {
    const mutationOptions: UseMutationOptions<RunsNewResponse, RunsNewError, Options<RunsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Measure seconds per step and batch sizes for a base model on the training card (the family's calibrate step)
 */
export const runsCalibrateMutation = (options?: Partial<Options<RunsCalibrateData>>): UseMutationOptions<RunsCalibrateResponse, RunsCalibrateError, Options<RunsCalibrateData>> => {
    const mutationOptions: UseMutationOptions<RunsCalibrateResponse, RunsCalibrateError, Options<RunsCalibrateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runsCalibrate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const runsGetQueryKey = (options: Options<RunsGetData>) => createQueryKey('runsGet', options);

/**
 * Get a run with its stage timeline, final metrics, departures from defaults and parent run
 */
export const runsGetOptions = (options: Options<RunsGetData>) => queryOptions<RunsGetResponse, RunsGetError, RunsGetResponse, ReturnType<typeof runsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await runsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: runsGetQueryKey(options)
});

/**
 * Continue a stopped or failed run from its last training state (same stage, same optimiser state)
 */
export const runsResumeMutation = (options?: Partial<Options<RunsResumeData>>): UseMutationOptions<RunsResumeResponse, RunsResumeError, Options<RunsResumeData>> => {
    const mutationOptions: UseMutationOptions<RunsResumeResponse, RunsResumeError, Options<RunsResumeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runsResume({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start a new stage from a checkpoint of this run with an explicit peak learning rate
 */
export const runsStageMutation = (options?: Partial<Options<RunsStageData>>): UseMutationOptions<RunsStageResponse, RunsStageError, Options<RunsStageData>> => {
    const mutationOptions: UseMutationOptions<RunsStageResponse, RunsStageError, Options<RunsStageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await runsStage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const checkpointsListQueryKey = (options: Options<CheckpointsListData>) => createQueryKey('checkpointsList', options);

/**
 * Checkpoints of a project or of one run, best validation WER first
 */
export const checkpointsListOptions = (options: Options<CheckpointsListData>) => queryOptions<CheckpointsListResponse, CheckpointsListError, CheckpointsListResponse, ReturnType<typeof checkpointsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkpointsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkpointsListQueryKey(options)
});

export const checkpointsGetQueryKey = (options: Options<CheckpointsGetData>) => createQueryKey('checkpointsGet', options);

/**
 * Get a checkpoint with its artifact, metrics and lineage
 */
export const checkpointsGetOptions = (options: Options<CheckpointsGetData>) => queryOptions<CheckpointsGetResponse, CheckpointsGetError, CheckpointsGetResponse, ReturnType<typeof checkpointsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkpointsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkpointsGetQueryKey(options)
});

/**
 * Average chosen checkpoints of a run with the family's average step; the result is a new checkpoint of the run
 */
export const checkpointsAverageMutation = (options?: Partial<Options<CheckpointsAverageData>>): UseMutationOptions<CheckpointsAverageResponse, CheckpointsAverageError, Options<CheckpointsAverageData>> => {
    const mutationOptions: UseMutationOptions<CheckpointsAverageResponse, CheckpointsAverageError, Options<CheckpointsAverageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await checkpointsAverage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const metricsGetQueryKey = (options: Options<MetricsGetData>) => createQueryKey('metricsGet', options);

/**
 * A run's metric series, binned server-side for charts (min and max per bucket), with checkpoint marks
 */
export const metricsGetOptions = (options: Options<MetricsGetData>) => queryOptions<MetricsGetResponse, MetricsGetError, MetricsGetResponse, ReturnType<typeof metricsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await metricsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: metricsGetQueryKey(options)
});

export const playbooksListQueryKey = (options?: Options<PlaybooksListData>) => createQueryKey('playbooksList', options);

/**
 * The playbooks Cadence ships, with their inputs, chain, stop conditions and estimate
 */
export const playbooksListOptions = (options?: Options<PlaybooksListData>) => queryOptions<PlaybooksListResponse, PlaybooksListError, PlaybooksListResponse, ReturnType<typeof playbooksListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await playbooksList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: playbooksListQueryKey(options)
});

export const playbooksGetQueryKey = (options: Options<PlaybooksGetData>) => createQueryKey('playbooksGet', options);

/**
 * One playbook with its inputs, chain, prompt template and estimate
 */
export const playbooksGetOptions = (options: Options<PlaybooksGetData>) => queryOptions<PlaybooksGetResponse, PlaybooksGetError, PlaybooksGetResponse, ReturnType<typeof playbooksGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await playbooksGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: playbooksGetQueryKey(options)
});

/**
 * Start a playbook session — dryRun answers the estimate, the plan and the rendered prompt without starting
 */
export const playbooksRunMutation = (options?: Partial<Options<PlaybooksRunData>>): UseMutationOptions<PlaybooksRunResponse, PlaybooksRunError, Options<PlaybooksRunData>> => {
    const mutationOptions: UseMutationOptions<PlaybooksRunResponse, PlaybooksRunError, Options<PlaybooksRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await playbooksRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Free content-store space by deleting superseded training states (always waits for an approval)
 */
export const artifactsEvictMutation = (options?: Partial<Options<ArtifactsEvictData>>): UseMutationOptions<ArtifactsEvictResponse, ArtifactsEvictError, Options<ArtifactsEvictData>> => {
    const mutationOptions: UseMutationOptions<ArtifactsEvictResponse, ArtifactsEvictError, Options<ArtifactsEvictData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await artifactsEvict({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const normalizersListQueryKey = (options?: Options<NormalizersListData>) => createQueryKey('normalizersList', options);

/**
 * List scoring normalizer versions (the text rules both sides of a WER are compared after, R21)
 */
export const normalizersListOptions = (options?: Options<NormalizersListData>) => queryOptions<NormalizersListResponse, NormalizersListError, NormalizersListResponse, ReturnType<typeof normalizersListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await normalizersList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: normalizersListQueryKey(options)
});

export const normalizersGetQueryKey = (options: Options<NormalizersGetData>) => createQueryKey('normalizersGet', options);

/**
 * Get a scoring normalizer version with its rules and the projects that use it
 */
export const normalizersGetOptions = (options: Options<NormalizersGetData>) => queryOptions<NormalizersGetResponse, NormalizersGetError, NormalizersGetResponse, ReturnType<typeof normalizersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await normalizersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: normalizersGetQueryKey(options)
});

export const goldenSetsListQueryKey = (options?: Options<GoldenSetsListData>) => createQueryKey('goldenSetsList', options);

/**
 * List golden set versions (frozen eval-only dataset versions tied to a scoring normalizer)
 */
export const goldenSetsListOptions = (options?: Options<GoldenSetsListData>) => queryOptions<GoldenSetsListResponse, GoldenSetsListError, GoldenSetsListResponse, ReturnType<typeof goldenSetsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await goldenSetsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: goldenSetsListQueryKey(options)
});

export const goldenSetsGetQueryKey = (options: Options<GoldenSetsGetData>) => createQueryKey('goldenSetsGet', options);

/**
 * Get a golden set version with its dataset, normalizer, size and the projects that use it
 */
export const goldenSetsGetOptions = (options: Options<GoldenSetsGetData>) => queryOptions<GoldenSetsGetResponse, GoldenSetsGetError, GoldenSetsGetResponse, ReturnType<typeof goldenSetsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await goldenSetsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: goldenSetsGetQueryKey(options)
});

/**
 * Freeze an eval-only dataset version and a scoring normalizer into a golden set (always waits for the admin's approval)
 */
export const goldenSetsFreezeMutation = (options?: Partial<Options<GoldenSetsFreezeData>>): UseMutationOptions<GoldenSetsFreezeResponse, GoldenSetsFreezeError, Options<GoldenSetsFreezeData>> => {
    const mutationOptions: UseMutationOptions<GoldenSetsFreezeResponse, GoldenSetsFreezeError, Options<GoldenSetsFreezeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await goldenSetsFreeze({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const evalsListQueryKey = (options: Options<EvalsListData>) => createQueryKey('evalsList', options);

/**
 * List the project's evals, newest first (cells omitted; evals.get has them)
 */
export const evalsListOptions = (options: Options<EvalsListData>) => queryOptions<EvalsListResponse, EvalsListError, EvalsListResponse, ReturnType<typeof evalsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await evalsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: evalsListQueryKey(options)
});

/**
 * Evaluate a checkpoint, model or base model against the baseline on golden sets × latency profiles × decoding; ?dryRun=true answers the plan
 */
export const evalsNewMutation = (options?: Partial<Options<EvalsNewData>>): UseMutationOptions<EvalsNewResponse, EvalsNewError, Options<EvalsNewData>> => {
    const mutationOptions: UseMutationOptions<EvalsNewResponse, EvalsNewError, Options<EvalsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await evalsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const evalsGetQueryKey = (options: Options<EvalsGetData>) => createQueryKey('evalsGet', options);

/**
 * Get an eval with its cells, deltas against the baseline with confidence intervals, and the worst utterances of a cell
 */
export const evalsGetOptions = (options: Options<EvalsGetData>) => queryOptions<EvalsGetResponse, EvalsGetError, EvalsGetResponse, ReturnType<typeof evalsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await evalsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: evalsGetQueryKey(options)
});

/**
 * Apply the project's gate (gates.yaml at main) to a finished eval and record the verdict
 */
export const evalsGateMutation = (options?: Partial<Options<EvalsGateData>>): UseMutationOptions<EvalsGateResponse, EvalsGateError, Options<EvalsGateData>> => {
    const mutationOptions: UseMutationOptions<EvalsGateResponse, EvalsGateError, Options<EvalsGateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await evalsGate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const gatesGetQueryKey = (options: Options<GatesGetData>) => createQueryKey('gatesGet', options);

/**
 * Get the project's gate (gates.yaml at main, with the defaults it departs from)
 */
export const gatesGetOptions = (options: Options<GatesGetData>) => queryOptions<GatesGetResponse, GatesGetError, GatesGetResponse, ReturnType<typeof gatesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await gatesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: gatesGetQueryKey(options)
});

/**
 * Commit a new gates.yaml to main (approval for agents); dryRun validates
 */
export const gatesEditMutation = (options?: Partial<Options<GatesEditData>>): UseMutationOptions<GatesEditResponse, GatesEditError, Options<GatesEditData>> => {
    const mutationOptions: UseMutationOptions<GatesEditResponse, GatesEditError, Options<GatesEditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await gatesEdit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Register a checkpoint whose latest gated eval passed as a model version, with its model card (approval for agents)
 */
export const modelsRegisterMutation = (options?: Partial<Options<ModelsRegisterData>>): UseMutationOptions<ModelsRegisterResponse, ModelsRegisterError, Options<ModelsRegisterData>> => {
    const mutationOptions: UseMutationOptions<ModelsRegisterResponse, ModelsRegisterError, Options<ModelsRegisterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await modelsRegister({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const modelsListQueryKey = (options?: Options<ModelsListData>) => createQueryKey('modelsList', options);

/**
 * List registered model versions (checkpoints whose gate passed) with their gate and lineage
 */
export const modelsListOptions = (options?: Options<ModelsListData>) => queryOptions<ModelsListResponse, ModelsListError, ModelsListResponse, ReturnType<typeof modelsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await modelsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: modelsListQueryKey(options)
});

export const modelsGetQueryKey = (options: Options<ModelsGetData>) => createQueryKey('modelsGet', options);

/**
 * Get a model version with its model card, gate, lineage and the projects that use it
 */
export const modelsGetOptions = (options: Options<ModelsGetData>) => queryOptions<ModelsGetResponse, ModelsGetError, ModelsGetResponse, ReturnType<typeof modelsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await modelsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: modelsGetQueryKey(options)
});

export const langpacksListQueryKey = (options: Options<LangpacksListData>) => createQueryKey('langpacksList', options);

/**
 * The project's language packs (lang/<locale>/ on main) and the locales Cadence ships packs for
 */
export const langpacksListOptions = (options: Options<LangpacksListData>) => queryOptions<LangpacksListResponse, LangpacksListError, LangpacksListResponse, ReturnType<typeof langpacksListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await langpacksList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: langpacksListQueryKey(options)
});

export const langpacksGetQueryKey = (options: Options<LangpacksGetData>) => createQueryKey('langpacksGet', options);

/**
 * One language pack with its files, scoring normalizer and boost lists; ETag is the pack's commit
 */
export const langpacksGetOptions = (options: Options<LangpacksGetData>) => queryOptions<LangpacksGetResponse, LangpacksGetError, LangpacksGetResponse, ReturnType<typeof langpacksGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await langpacksGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: langpacksGetQueryKey(options)
});

/**
 * Write or delete files of one language pack in one commit (If-Match is the pack's commit)
 */
export const langpacksEditMutation = (options?: Partial<Options<LangpacksEditData>>): UseMutationOptions<LangpacksEditResponse, LangpacksEditError, Options<LangpacksEditData>> => {
    const mutationOptions: UseMutationOptions<LangpacksEditResponse, LangpacksEditError, Options<LangpacksEditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await langpacksEdit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Replace one boost list of a language pack (terms and weight) in one commit
 */
export const boostEditMutation = (options?: Partial<Options<BoostEditData>>): UseMutationOptions<BoostEditResponse, BoostEditError, Options<BoostEditData>> => {
    const mutationOptions: UseMutationOptions<BoostEditResponse, BoostEditError, Options<BoostEditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await boostEdit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const registryLineageQueryKey = (options: Options<RegistryLineageData>) => createQueryKey('registryLineage', options);

/**
 * The lineage graph around an entity — what it was built from (upstream) and what uses it (downstream)
 */
export const registryLineageOptions = (options: Options<RegistryLineageData>) => queryOptions<RegistryLineageResponse, RegistryLineageError, RegistryLineageResponse, ReturnType<typeof registryLineageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await registryLineage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: registryLineageQueryKey(options)
});

export const experimentsListQueryKey = (options: Options<ExperimentsListData>) => createQueryKey('experimentsList', options);

/**
 * List the project's experiments, newest first (question, mix, base model, run count, best run, sweeps)
 */
export const experimentsListOptions = (options: Options<ExperimentsListData>) => queryOptions<ExperimentsListResponse, ExperimentsListError, ExperimentsListResponse, ReturnType<typeof experimentsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await experimentsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: experimentsListQueryKey(options)
});

/**
 * Open an experiment — a question with a fixed mix revision and base model — that runs and sweeps join
 */
export const experimentsNewMutation = (options?: Partial<Options<ExperimentsNewData>>): UseMutationOptions<ExperimentsNewResponse, ExperimentsNewError, Options<ExperimentsNewData>> => {
    const mutationOptions: UseMutationOptions<ExperimentsNewResponse, ExperimentsNewError, Options<ExperimentsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await experimentsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const experimentsGetQueryKey = (options: Options<ExperimentsGetData>) => createQueryKey('experimentsGet', options);

/**
 * Get an experiment with its runs as parameters × metrics, the best run by validation WER, and its sweeps
 */
export const experimentsGetOptions = (options: Options<ExperimentsGetData>) => queryOptions<ExperimentsGetResponse, ExperimentsGetError, ExperimentsGetResponse, ReturnType<typeof experimentsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await experimentsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: experimentsGetQueryKey(options)
});

/**
 * Run a grid or random sweep over recipe parameters as sequential runs of the experiment under a GPU-hour cap
 */
export const sweepsRunMutation = (options?: Partial<Options<SweepsRunData>>): UseMutationOptions<SweepsRunResponse, SweepsRunError, Options<SweepsRunData>> => {
    const mutationOptions: UseMutationOptions<SweepsRunResponse, SweepsRunError, Options<SweepsRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sweepsRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const audioGetQueryKey = (options: Options<AudioGetData>) => createQueryKey('audioGet', options);

/**
 * A span of an utterance's audio as 16 kHz 16-bit PCM WAV, with byte ranges; a signed link plays without a session
 *
 * The utterance's audio, or a span of it, as a 16 kHz 16-bit PCM WAV file (the stored file itself when it is already one and the whole file is asked). Byte ranges (Range: bytes=…) answer 206 Partial Content. A request signed by audio.sign (exp, viewer, sig) needs no session and is attributed to its viewer. Every play — a request from byte 0 — is written to the audit log with the viewer and the span. Agent session tokens are refused.
 *
 */
export const audioGetOptions = (options: Options<AudioGetData>) => queryOptions<AudioGetResponse, AudioGetError, AudioGetResponse, ReturnType<typeof audioGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await audioGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: audioGetQueryKey(options)
});

export const audioGetInfiniteQueryKey = (options: Options<AudioGetData>): QueryKey<Options<AudioGetData>> => createQueryKey('audioGet', options, true);

/**
 * A span of an utterance's audio as 16 kHz 16-bit PCM WAV, with byte ranges; a signed link plays without a session
 *
 * The utterance's audio, or a span of it, as a 16 kHz 16-bit PCM WAV file (the stored file itself when it is already one and the whole file is asked). Byte ranges (Range: bytes=…) answer 206 Partial Content. A request signed by audio.sign (exp, viewer, sig) needs no session and is attributed to its viewer. Every play — a request from byte 0 — is written to the audit log with the viewer and the span. Agent session tokens are refused.
 *
 */
export const audioGetInfiniteOptions = (options: Options<AudioGetData>) => {
    const opts = infiniteQueryOptions<AudioGetResponse, AudioGetError, InfiniteData<AudioGetResponse>, QueryKey<Options<AudioGetData>>, number | Pick<QueryKey<Options<AudioGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AudioGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await audioGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: audioGetInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Mint a short-lived signed link that plays a span of an utterance (bound to the span, the viewer and an expiry)
 *
 * A link a media element can play without headers: audio.get with exp, viewer and sig. It is bound to the utterance, the span, the channel and the signed-in viewer, and expires after defaults media.signed_link_ttl_s. Minting writes an audit row (who, which span). Not a command: it changes no entity, so it takes no Idempotency-Key, If-Match or dryRun. Agent session tokens are refused.
 *
 */
export const audioSignMutation = (options?: Partial<Options<AudioSignData>>): UseMutationOptions<AudioSignResponse, AudioSignError, Options<AudioSignData>> => {
    const mutationOptions: UseMutationOptions<AudioSignResponse, AudioSignError, Options<AudioSignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await audioSign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const peaksGetQueryKey = (options: Options<PeaksGetData>) => createQueryKey('peaksGet', options);

/**
 * Min/max peaks per channel of an utterance (or a span) at a resolution, for the waveform track
 *
 * int8 min/max pairs (value / 127 = sample) per hop and channel, frames × channels × [min, max], base64. Peaks are stored once per audio as a peaks artifact (cadence.peaks/2): the 10 ms base level and, for long audio, coarser levels (×16 each), computed when a dataset version is registered (a frozen version's members, and a draft's segments whose files the control plane reads without a decoder) by the media.peaks job. A request reads only the span it asks for from the coarsest stored level that divides hopMs and pools it; audio with no stored peaks is computed on this request and stored (computed: true).
 *
 */
export const peaksGetOptions = (options: Options<PeaksGetData>) => queryOptions<PeaksGetResponse, PeaksGetError, PeaksGetResponse, ReturnType<typeof peaksGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await peaksGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: peaksGetQueryKey(options)
});

export const peaksGetInfiniteQueryKey = (options: Options<PeaksGetData>): QueryKey<Options<PeaksGetData>> => createQueryKey('peaksGet', options, true);

/**
 * Min/max peaks per channel of an utterance (or a span) at a resolution, for the waveform track
 *
 * int8 min/max pairs (value / 127 = sample) per hop and channel, frames × channels × [min, max], base64. Peaks are stored once per audio as a peaks artifact (cadence.peaks/2): the 10 ms base level and, for long audio, coarser levels (×16 each), computed when a dataset version is registered (a frozen version's members, and a draft's segments whose files the control plane reads without a decoder) by the media.peaks job. A request reads only the span it asks for from the coarsest stored level that divides hopMs and pools it; audio with no stored peaks is computed on this request and stored (computed: true).
 *
 */
export const peaksGetInfiniteOptions = (options: Options<PeaksGetData>) => {
    const opts = infiniteQueryOptions<PeaksGetResponse, PeaksGetError, InfiniteData<PeaksGetResponse>, QueryKey<Options<PeaksGetData>>, number | Pick<QueryKey<Options<PeaksGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<PeaksGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    start: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await peaksGet({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: peaksGetInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const spectrogramGetQueryKey = (options: Options<SpectrogramGetData>) => createQueryKey('spectrogramGet', options);

/**
 * The spectrogram tile pyramid of an utterance's audio — its manifest, or one tile; the first request builds it
 *
 * For audio longer than views.audio.browser_stft_max_s the audio view reads a server tile pyramid: the newest spectrogram_tiles artifact of the utterance's audio at the views.audio settings (or one spectrogram_tiles@1 wrote in a pipeline). Without tile: the manifest (JSON). With tile=c<ch>/l<level>/<index>: that tile's bytes (uint8 dB, bins × 512 frames, dB = -120 + 0.5 × value). When no pyramid exists, a manifest request starts the media.spectrogram job that builds it once in the control plane (any audio the view plays: a stored utterance, a segment or window of a file on a mount) and answers 202 with the job (Retry-After 2); requests while it runs answer the same job, so each audio is built once. A failed build answers media-tiles-failed until media.tiles_retry_s has passed, then builds again; audio longer than media.tiles_max_s is refused. Narrowband audio (8 kHz origin by its estimated bandwidth) keeps bins up to 4 kHz (manifest narrowband, bandwidthHz). A tile request with no pyramid answers 404.
 *
 */
export const spectrogramGetOptions = (options: Options<SpectrogramGetData>) => queryOptions<SpectrogramGetResponse, SpectrogramGetError, SpectrogramGetResponse, ReturnType<typeof spectrogramGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await spectrogramGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: spectrogramGetQueryKey(options)
});

export const wordsGetQueryKey = (options: Options<WordsGetData>) => createQueryKey('wordsGet', options);

/**
 * An utterance's hypothesis words with times (marked S/D/I against the reference by a scores artifact) and its reference words at aligned times
 *
 * The audio view's word tracks for one utterance: its row of a hypotheses artifact (words with start, end and confidence; partial events of a streaming decode), and, with scores, the alignment of that utterance's row in the scores artifact — each hypothesis word marked =, S or I (with the reference word for S), and the reference words the hypothesis deleted placed between hypothesis words. With goldenSet (or alignment), the reference track: the utterance's row of the golden set's newest reference alignment (align_reference) — its words at their aligned times, or the text and the reason when it stayed unaligned. At least one of hypotheses, goldenSet and alignment is required.
 *
 */
export const wordsGetOptions = (options: Options<WordsGetData>) => queryOptions<WordsGetResponse, WordsGetError, WordsGetResponse, ReturnType<typeof wordsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await wordsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: wordsGetQueryKey(options)
});

/**
 * Open a manual transcription test of one to three models on a file, the microphone or an utterance span; answers the live socket's URL and a single-use ticket
 *
 * A manual test (R47): one to three targets (a checkpoint, a model version or a base model version, each with its latency profile, language and optional boost list) receive the same audio and stream partial and final words back over the live channel (stream.connect, R48). The answer carries the session (trs_…), the socket URL and a single-use ticket valid transcriptions.ticket_ttl_s (60 s); the socket also checks Origin. The session is an interactive job (R49): it reserves the family's interactive memory on a card beside training under the card's cap, never beside a benchmark, at the highest queue priority, and counts against the project's daily budgets.manual_test_gpu_hours_per_project_per_day (lease wall time). One open session per person, at most transcriptions.session_max_minutes long, closed after transcriptions.idle_minutes without audio or keepalive. Nothing else is stored: no audio, text or metric. ?dryRun=true checks the targets and the allowance and answers the session without opening it (no ticket). Agent session tokens are refused.
 *
 */
export const transcriptionsNewMutation = (options?: Partial<Options<TranscriptionsNewData>>): UseMutationOptions<TranscriptionsNewResponse, TranscriptionsNewError, Options<TranscriptionsNewData>> => {
    const mutationOptions: UseMutationOptions<TranscriptionsNewResponse, TranscriptionsNewError, Options<TranscriptionsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await transcriptionsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const streamConnectQueryKey = (options: Options<StreamConnectData>) => createQueryKey('streamConnect', options);

/**
 * The live channel of a transcription session — a WebSocket opened with the session's single-use ticket from a same-origin page
 *
 * Upgrades to a WebSocket (no WebRTC, R48). The ticket from transcriptions.new is single-use and valid 60 s; the Origin header must name this server (or one of CADENCE_ALLOWED_ORIGINS); the signed-in user must be the session's. Client → server: text frames are LiveClientMessage (start first, then fileEnd, finalize, keepalive, ping, end) and binary frames carry audio — PCM16 little-endian mono at the capture rate in frames of at most transcriptions.frame_ms (20 ms) for the microphone, or a file's bytes. Server → client: LiveServerMessage (waiting while the job is queued or loading, started, partial, final, stats, pong, error, summary). The socket closes with 1000 after summary; 4001 idle, 4002 session cap, 4003 the worker was lost, 4004 the job could not start, 1013 backpressure (the worker fell behind), 1001 the control plane is stopping.
 *
 */
export const streamConnectOptions = (options: Options<StreamConnectData>) => queryOptions<StreamConnectResponse, StreamConnectError, StreamConnectResponse, ReturnType<typeof streamConnectQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await streamConnect({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: streamConnectQueryKey(options)
});

export const workerLiveConnectQueryKey = (options: Options<WorkerLiveConnectData>) => createQueryKey('workerLiveConnect', options);

/**
 * A worker's live job dials out to its session (WebSocket) and receives the browser's messages unchanged
 *
 * The pull model of R14 for the live channel: a worker running an interactive job (a family's live role kind) loads every target, then dials this socket with the lease's live token (header Cadence-Live-Token, from the lease's env CADENCE_LIVE_TOKEN) or its worker credential (Bearer cwk_…, the lease's host). The relay forwards the browser's frames byte for byte (it reads only "type") and the worker's LiveServerMessage frames back. One dial serves one session; a dial for a session that ended answers 409 lease-ended.
 *
 */
export const workerLiveConnectOptions = (options: Options<WorkerLiveConnectData>) => queryOptions<WorkerLiveConnectResponse, WorkerLiveConnectError, WorkerLiveConnectResponse, ReturnType<typeof workerLiveConnectQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await workerLiveConnect({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: workerLiveConnectQueryKey(options)
});

export const mountsListQueryKey = (options?: Options<MountsListData>) => createQueryKey('mountsList', options);

/**
 * Registered mounts with their health and last scan
 */
export const mountsListOptions = (options?: Options<MountsListData>) => queryOptions<MountsListResponse, MountsListError, MountsListResponse, ReturnType<typeof mountsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mountsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mountsListQueryKey(options)
});

/**
 * Register a local path, NFS/SMB path, S3-compatible bucket or Hub repository (registry approval, the admin decides)
 */
export const mountsNewMutation = (options?: Partial<Options<MountsNewData>>): UseMutationOptions<MountsNewResponse, MountsNewError, Options<MountsNewData>> => {
    const mutationOptions: UseMutationOptions<MountsNewResponse, MountsNewError, Options<MountsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mountsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mountsGetQueryKey = (options: Options<MountsGetData>) => createQueryKey('mountsGet', options);

/**
 * Get a mount with its health, last scan, utterance URIs and content-store copies
 */
export const mountsGetOptions = (options: Options<MountsGetData>) => queryOptions<MountsGetResponse, MountsGetError, MountsGetResponse, ReturnType<typeof mountsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mountsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mountsGetQueryKey(options)
});

/**
 * Rescan a mount — files, bytes, top-level entries and content-store blob copies — and check its health (202 with the job)
 */
export const mountsScanMutation = (options?: Partial<Options<MountsScanData>>): UseMutationOptions<MountsScanResponse, MountsScanError, Options<MountsScanData>> => {
    const mutationOptions: UseMutationOptions<MountsScanResponse, MountsScanError, Options<MountsScanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mountsScan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check a mount's health on a worker now — reachable, free space, a throughput sample (202 with the job)
 */
export const mountsVerifyMutation = (options?: Partial<Options<MountsVerifyData>>): UseMutationOptions<MountsVerifyResponse, MountsVerifyError, Options<MountsVerifyData>> => {
    const mutationOptions: UseMutationOptions<MountsVerifyResponse, MountsVerifyError, Options<MountsVerifyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mountsVerify({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const storageGetQueryKey = (options?: Options<StorageGetData>) => createQueryKey('storageGet', options);

/**
 * Cache use, water marks, per-project quotas, pinned and evictable dataset versions
 */
export const storageGetOptions = (options?: Options<StorageGetData>) => queryOptions<StorageGetResponse, StorageGetError, StorageGetResponse, ReturnType<typeof storageGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await storageGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: storageGetQueryKey(options)
});

/**
 * Copy a dataset version's evicted shards back into the local cache from their mount copies (resumable job)
 */
export const datasetsMaterializeMutation = (options?: Partial<Options<DatasetsMaterializeData>>): UseMutationOptions<DatasetsMaterializeResponse, DatasetsMaterializeError, Options<DatasetsMaterializeData>> => {
    const mutationOptions: UseMutationOptions<DatasetsMaterializeResponse, DatasetsMaterializeError, Options<DatasetsMaterializeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await datasetsMaterialize({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Free a dataset version's shards from the local cache when every shard also lives on a mount (202 with the job)
 */
export const datasetsEvictMutation = (options?: Partial<Options<DatasetsEvictData>>): UseMutationOptions<DatasetsEvictResponse, DatasetsEvictError, Options<DatasetsEvictData>> => {
    const mutationOptions: UseMutationOptions<DatasetsEvictResponse, DatasetsEvictError, Options<DatasetsEvictData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await datasetsEvict({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Export a frozen dataset version as Lhotse Shar, a NeMo manifest or a Cadence bundle (to a writable mount or the content store), or to the Hugging Face Hub (approval); 202 with the job
 */
export const datasetsExportMutation = (options?: Partial<Options<DatasetsExportData>>): UseMutationOptions<DatasetsExportResponse, DatasetsExportError, Options<DatasetsExportData>> => {
    const mutationOptions: UseMutationOptions<DatasetsExportResponse, DatasetsExportError, Options<DatasetsExportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await datasetsExport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const exportsListQueryKey = (options: Options<ExportsListData>) => createQueryKey('exportsList', options);

/**
 * Dataset exports run in a project, newest first
 */
export const exportsListOptions = (options: Options<ExportsListData>) => queryOptions<ExportsListResponse, ExportsListError, ExportsListResponse, ReturnType<typeof exportsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportsListQueryKey(options)
});

export const exportsGetQueryKey = (options: Options<ExportsGetData>) => createQueryKey('exportsGet', options);

/**
 * Get a dataset export with its state, target, files, bytes, mount copies and Hub commit
 */
export const exportsGetOptions = (options: Options<ExportsGetData>) => queryOptions<ExportsGetResponse, ExportsGetError, ExportsGetResponse, ReturnType<typeof exportsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportsGetQueryKey(options)
});

export const guidelinesGetQueryKey = (options: Options<GuidelinesGetData>) => createQueryKey('guidelinesGet', options);

/**
 * The annotation guidelines a batch pinned — the Markdown file at the batch's commit of the project repository
 */
export const guidelinesGetOptions = (options: Options<GuidelinesGetData>) => queryOptions<GuidelinesGetResponse, GuidelinesGetError, GuidelinesGetResponse, ReturnType<typeof guidelinesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await guidelinesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: guidelinesGetQueryKey(options)
});

export const textsGetQueryKey = (options: Options<TextsGetData>) => createQueryKey('textsGet', options);

/**
 * Read a text of the content store the registry names to be read — a dataset version's card (Markdown)
 */
export const textsGetOptions = (options: Options<TextsGetData>) => queryOptions<TextsGetResponse, TextsGetError, TextsGetResponse, ReturnType<typeof textsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await textsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: textsGetQueryKey(options)
});

/**
 * Export the project as a Cadence project bundle (its repository at a commit, data.lock and every registry version it references, with their content) to a directory on a writable mount; 201 with the export
 */
export const projectsExportMutation = (options?: Partial<Options<ProjectsExportData>>): UseMutationOptions<ProjectsExportResponse, ProjectsExportError, Options<ProjectsExportData>> => {
    const mutationOptions: UseMutationOptions<ProjectsExportResponse, ProjectsExportError, Options<ProjectsExportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await projectsExport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Import a Cadence project bundle's registry versions this instance lacks and adopt every version the bundle's project adopted into this project (approval for everyone); 201 with the import job
 */
export const bundlesAdoptMutation = (options?: Partial<Options<BundlesAdoptData>>): UseMutationOptions<BundlesAdoptResponse, BundlesAdoptError, Options<BundlesAdoptData>> => {
    const mutationOptions: UseMutationOptions<BundlesAdoptResponse, BundlesAdoptError, Options<BundlesAdoptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bundlesAdopt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Hours per language and split of a dataset version after filters (metadata only; nothing is written)
 */
export const datasetsPreviewMutation = (options?: Partial<Options<DatasetsPreviewData>>): UseMutationOptions<DatasetsPreviewResponse, DatasetsPreviewError, Options<DatasetsPreviewData>> => {
    const mutationOptions: UseMutationOptions<DatasetsPreviewResponse, DatasetsPreviewError, Options<DatasetsPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await datasetsPreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Freeze a draft dataset version — leakage check, then cut its segments into the content store (202 with the pipeline run)
 */
export const datasetsFreezeMutation = (options?: Partial<Options<DatasetsFreezeData>>): UseMutationOptions<DatasetsFreezeResponse, DatasetsFreezeError, Options<DatasetsFreezeData>> => {
    const mutationOptions: UseMutationOptions<DatasetsFreezeResponse, DatasetsFreezeError, Options<DatasetsFreezeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await datasetsFreeze({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const utterancesSearchQueryKey = (options?: Options<UtterancesSearchData>) => createQueryKey('utterancesSearch', options);

/**
 * Search utterances by transcript text, source, language, speaker, duration, origin and split
 */
export const utterancesSearchOptions = (options?: Options<UtterancesSearchData>) => queryOptions<UtterancesSearchResponse, UtterancesSearchError, UtterancesSearchResponse, ReturnType<typeof utterancesSearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await utterancesSearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: utterancesSearchQueryKey(options)
});

export const utterancesSearchInfiniteQueryKey = (options?: Options<UtterancesSearchData>): QueryKey<Options<UtterancesSearchData>> => createQueryKey('utterancesSearch', options, true);

/**
 * Search utterances by transcript text, source, language, speaker, duration, origin and split
 */
export const utterancesSearchInfiniteOptions = (options?: Options<UtterancesSearchData>) => {
    const opts = infiniteQueryOptions<UtterancesSearchResponse, UtterancesSearchError, InfiniteData<UtterancesSearchResponse>, QueryKey<Options<UtterancesSearchData>>, string | Pick<QueryKey<Options<UtterancesSearchData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<UtterancesSearchData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    after: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await utterancesSearch({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: utterancesSearchInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const auxiliariesListQueryKey = (options?: Options<AuxiliariesListData>) => createQueryKey('auxiliariesList', options);

/**
 * List auxiliary model versions (LID classifiers, pseudo-label members, aligners) with their licence check
 */
export const auxiliariesListOptions = (options?: Options<AuxiliariesListData>) => queryOptions<AuxiliariesListResponse, AuxiliariesListError, AuxiliariesListResponse, ReturnType<typeof auxiliariesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await auxiliariesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: auxiliariesListQueryKey(options)
});

export const auxiliariesGetQueryKey = (options: Options<AuxiliariesGetData>) => createQueryKey('auxiliariesGet', options);

/**
 * Get an auxiliary model version with its payload, the projects that adopted it and whether its service answers
 */
export const auxiliariesGetOptions = (options: Options<AuxiliariesGetData>) => queryOptions<AuxiliariesGetResponse, AuxiliariesGetError, AuxiliariesGetResponse, ReturnType<typeof auxiliariesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await auxiliariesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: auxiliariesGetQueryKey(options)
});

export const triageListQueryKey = (options: Options<TriageListData>) => createQueryKey('triageList', options);

/**
 * The project's triage queue — segments whose pseudo-label members disagreed, newest first
 */
export const triageListOptions = (options: Options<TriageListData>) => queryOptions<TriageListResponse, TriageListError, TriageListResponse, ReturnType<typeof triageListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await triageList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: triageListQueryKey(options)
});

/**
 * Archive a registry version (soft delete, the admin's); refused while anything uses it
 */
export const versionsArchiveMutation = (options?: Partial<Options<VersionsArchiveData>>): UseMutationOptions<VersionsArchiveResponse, VersionsArchiveError, Options<VersionsArchiveData>> => {
    const mutationOptions: UseMutationOptions<VersionsArchiveResponse, VersionsArchiveError, Options<VersionsArchiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await versionsArchive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const batchesListQueryKey = (options: Options<BatchesListData>) => createQueryKey('batchesList', options);

/**
 * List the project's annotation batches, newest first, with progress and agreement
 */
export const batchesListOptions = (options: Options<BatchesListData>) => queryOptions<BatchesListResponse, BatchesListError, BatchesListResponse, ReturnType<typeof batchesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await batchesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: batchesListQueryKey(options)
});

/**
 * Sample an annotation batch from a dataset version's segments (stratified, the caller's channel by default)
 */
export const batchesNewMutation = (options?: Partial<Options<BatchesNewData>>): UseMutationOptions<BatchesNewResponse, BatchesNewError, Options<BatchesNewData>> => {
    const mutationOptions: UseMutationOptions<BatchesNewResponse, BatchesNewError, Options<BatchesNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await batchesNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const batchesGetQueryKey = (options: Options<BatchesGetData>) => createQueryKey('batchesGet', options);

/**
 * Get an annotation batch — progress, inter-annotator agreement, the adjudication queue, reviewers and whether it can freeze
 */
export const batchesGetOptions = (options: Options<BatchesGetData>) => queryOptions<BatchesGetResponse, BatchesGetError, BatchesGetResponse, ReturnType<typeof batchesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await batchesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: batchesGetQueryKey(options)
});

/**
 * Freeze a finished batch into a golden set (via goldenSets.freeze) or a training dataset version — an approval
 */
export const batchesFreezeMutation = (options?: Partial<Options<BatchesFreezeData>>): UseMutationOptions<BatchesFreezeResponse, BatchesFreezeError, Options<BatchesFreezeData>> => {
    const mutationOptions: UseMutationOptions<BatchesFreezeResponse, BatchesFreezeError, Options<BatchesFreezeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await batchesFreeze({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const batchItemsListQueryKey = (options: Options<BatchItemsListData>) => createQueryKey('batchItemsList', options);

/**
 * The items of a batch — the caller's annotation queue (mine), the adjudication queue, or all
 *
 * queue=mine lists what the caller may annotate next (blind: another annotator's text is never shown), then what the caller already annotated; queue=adjudication the disputed items (admin or an adjudicator); queue=all every item (not for reviewers). A reviewer sees only their own annotations.
 *
 */
export const batchItemsListOptions = (options: Options<BatchItemsListData>) => queryOptions<BatchItemsListResponse, BatchItemsListError, BatchItemsListResponse, ReturnType<typeof batchItemsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await batchItemsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: batchItemsListQueryKey(options)
});

export const batchItemsGetQueryKey = (options: Options<BatchItemsGetData>) => createQueryKey('batchItemsGet', options);

/**
 * One batch item — its segment, audio window, the bot's script around it, the prefill and the annotations the caller may see
 */
export const batchItemsGetOptions = (options: Options<BatchItemsGetData>) => queryOptions<BatchItemsGetResponse, BatchItemsGetError, BatchItemsGetResponse, ReturnType<typeof batchItemsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await batchItemsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: batchItemsGetQueryKey(options)
});

/**
 * Adjudicate an item — set its final transcript, tags and entity spans, or exclude it (admin or an adjudicator)
 */
export const batchItemsAcceptMutation = (options?: Partial<Options<BatchItemsAcceptData>>): UseMutationOptions<BatchItemsAcceptResponse, BatchItemsAcceptError, Options<BatchItemsAcceptData>> => {
    const mutationOptions: UseMutationOptions<BatchItemsAcceptResponse, BatchItemsAcceptError, Options<BatchItemsAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await batchItemsAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit the caller's annotation of an item — done, skipped or flagged, with text, tags and entity spans
 *
 * A person's own annotation (agents and API keys are refused). Submitting again replaces the caller's annotation until the item is adjudicated or the batch freezes. The second annotation of a double item comes from another person.
 *
 */
export const annotationsNewMutation = (options?: Partial<Options<AnnotationsNewData>>): UseMutationOptions<AnnotationsNewResponse, AnnotationsNewError, Options<AnnotationsNewData>> => {
    const mutationOptions: UseMutationOptions<AnnotationsNewResponse, AnnotationsNewError, Options<AnnotationsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await annotationsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const invitationsListQueryKey = (options: Options<InvitationsListData>) => createQueryKey('invitationsList', options);

/**
 * The reviewers invited to a batch (admin)
 */
export const invitationsListOptions = (options: Options<InvitationsListData>) => queryOptions<InvitationsListResponse, InvitationsListError, InvitationsListResponse, ReturnType<typeof invitationsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await invitationsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: invitationsListQueryKey(options)
});

/**
 * Invite a reviewer to a batch — a link that opens this batch's items only, play without download (admin)
 *
 * Creates the reviewer (a person with no password) when the name is new, and an invitation link (shown once). The link signs the reviewer in to this batch only: its items and their audio through signed links (no download), nothing else. It expires at expiresAt (at most annotation.invitation_max_days, never after the batch's due date) and when the batch freezes. Revoke it with credentials.revoke.
 *
 */
export const invitationsNewMutation = (options?: Partial<Options<InvitationsNewData>>): UseMutationOptions<InvitationsNewResponse, InvitationsNewError, Options<InvitationsNewData>> => {
    const mutationOptions: UseMutationOptions<InvitationsNewResponse, InvitationsNewError, Options<InvitationsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await invitationsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Open a reviewer invitation — sign in to the one batch the link names (no password)
 */
export const authAcceptMutation = (options?: Partial<Options<AuthAcceptData>>): UseMutationOptions<AuthAcceptResponse, AuthAcceptError, Options<AuthAcceptData>> => {
    const mutationOptions: UseMutationOptions<AuthAcceptResponse, AuthAcceptError, Options<AuthAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resolve a triage item by accepting its best candidate as the segment's human transcript
 */
export const triageAcceptMutation = (options?: Partial<Options<TriageAcceptData>>): UseMutationOptions<TriageAcceptResponse, TriageAcceptError, Options<TriageAcceptData>> => {
    const mutationOptions: UseMutationOptions<TriageAcceptResponse, TriageAcceptError, Options<TriageAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await triageAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resolve a triage item with a person's own transcript of the segment
 */
export const triageCorrectMutation = (options?: Partial<Options<TriageCorrectData>>): UseMutationOptions<TriageCorrectResponse, TriageCorrectError, Options<TriageCorrectData>> => {
    const mutationOptions: UseMutationOptions<TriageCorrectResponse, TriageCorrectError, Options<TriageCorrectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await triageCorrect({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resolve a triage item by dropping the segment (no transcript is written)
 */
export const triageRejectMutation = (options?: Partial<Options<TriageRejectData>>): UseMutationOptions<TriageRejectResponse, TriageRejectError, Options<TriageRejectData>> => {
    const mutationOptions: UseMutationOptions<TriageRejectResponse, TriageRejectError, Options<TriageRejectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await triageReject({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const tracksGetQueryKey = (options: Options<TracksGetData>) => createQueryKey('tracksGet', options);

/**
 * Level, voice activity and estimated bandwidth per channel of an utterance's audio, for the audio view's tracks
 *
 * Level in dBFS per hop and channel, speech regions from an energy voice activity detector (the channel's noise floor plus annotation.vad_margin_db), the estimated bandwidth (the highest frequency whose band keeps energy within annotation.bandwidth_floor_db of the loudest band; audio of 8 kHz origin shows ≤ 4 kHz) and, when the audio has a caller and a bot channel, the end-of-utterance gap (the caller's last speech end to the bot's next speech start).
 *
 */
export const tracksGetOptions = (options: Options<TracksGetData>) => queryOptions<TracksGetResponse, TracksGetError, TracksGetResponse, ReturnType<typeof tracksGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await tracksGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: tracksGetQueryKey(options)
});

/**
 * Align the reference texts of several golden sets in one pipeline run (word timings for emission delay)
 */
export const goldenSetsAlignMutation = (options?: Partial<Options<GoldenSetsAlignData>>): UseMutationOptions<GoldenSetsAlignResponse, GoldenSetsAlignError, Options<GoldenSetsAlignData>> => {
    const mutationOptions: UseMutationOptions<GoldenSetsAlignResponse, GoldenSetsAlignError, Options<GoldenSetsAlignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await goldenSetsAlign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Export a model version for serving, one deployable per latency profile (GPU spend)
 */
export const modelsExportMutation = (options?: Partial<Options<ModelsExportData>>): UseMutationOptions<ModelsExportResponse, ModelsExportError, Options<ModelsExportData>> => {
    const mutationOptions: UseMutationOptions<ModelsExportResponse, ModelsExportError, Options<ModelsExportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await modelsExport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check that an export decodes like the model it came from, through the staging server (R31; GPU spend)
 */
export const modelsParityMutation = (options?: Partial<Options<ModelsParityData>>): UseMutationOptions<ModelsParityResponse, ModelsParityError, Options<ModelsParityData>> => {
    const mutationOptions: UseMutationOptions<ModelsParityResponse, ModelsParityError, Options<ModelsParityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await modelsParity({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stream audio through the staging server at real-time pace at each concurrency level and judge the latency budget (R31)
 */
export const modelsBenchmarkMutation = (options?: Partial<Options<ModelsBenchmarkData>>): UseMutationOptions<ModelsBenchmarkResponse, ModelsBenchmarkError, Options<ModelsBenchmarkData>> => {
    const mutationOptions: UseMutationOptions<ModelsBenchmarkResponse, ModelsBenchmarkError, Options<ModelsBenchmarkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await modelsBenchmark({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deploymentTargetsListQueryKey = (options?: Options<DeploymentTargetsListData>) => createQueryKey('deploymentTargetsList', options);

/**
 * Deployment targets (staging and delivery) with what they serve, their chain head and the instance signing key
 */
export const deploymentTargetsListOptions = (options?: Options<DeploymentTargetsListData>) => queryOptions<DeploymentTargetsListResponse, DeploymentTargetsListError, DeploymentTargetsListResponse, ReturnType<typeof deploymentTargetsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await deploymentTargetsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: deploymentTargetsListQueryKey(options)
});

/**
 * Ask for a new deployment target (registry approval for everyone, the admin decides)
 */
export const deploymentTargetsNewMutation = (options?: Partial<Options<DeploymentTargetsNewData>>): UseMutationOptions<DeploymentTargetsNewResponse, DeploymentTargetsNewError, Options<DeploymentTargetsNewData>> => {
    const mutationOptions: UseMutationOptions<DeploymentTargetsNewResponse, DeploymentTargetsNewError, Options<DeploymentTargetsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deploymentTargetsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deploymentTargetsGetQueryKey = (options: Options<DeploymentTargetsGetData>) => createQueryKey('deploymentTargetsGet', options);

/**
 * Get a deployment target with what it serves and its chain head
 */
export const deploymentTargetsGetOptions = (options: Options<DeploymentTargetsGetData>) => queryOptions<DeploymentTargetsGetResponse, DeploymentTargetsGetError, DeploymentTargetsGetResponse, ReturnType<typeof deploymentTargetsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await deploymentTargetsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: deploymentTargetsGetQueryKey(options)
});

/**
 * Change a deployment target (registry approval for everyone; a delivery target's chain gets a target-changed record)
 */
export const deploymentTargetsEditMutation = (options?: Partial<Options<DeploymentTargetsEditData>>): UseMutationOptions<DeploymentTargetsEditResponse, DeploymentTargetsEditError, Options<DeploymentTargetsEditData>> => {
    const mutationOptions: UseMutationOptions<DeploymentTargetsEditResponse, DeploymentTargetsEditError, Options<DeploymentTargetsEditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deploymentTargetsEdit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive a deployment target (soft, the admin's); it takes no new deployments or promotions, its chain stays
 */
export const deploymentTargetsArchiveMutation = (options?: Partial<Options<DeploymentTargetsArchiveData>>): UseMutationOptions<DeploymentTargetsArchiveResponse, DeploymentTargetsArchiveError, Options<DeploymentTargetsArchiveData>> => {
    const mutationOptions: UseMutationOptions<DeploymentTargetsArchiveResponse, DeploymentTargetsArchiveError, Options<DeploymentTargetsArchiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deploymentTargetsArchive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const promotionsListQueryKey = (options: Options<PromotionsListData>) => createQueryKey('promotionsList', options);

/**
 * A delivery target's promotion record chain, oldest first, every record re-verified on read
 */
export const promotionsListOptions = (options: Options<PromotionsListData>) => queryOptions<PromotionsListResponse, PromotionsListError, PromotionsListResponse, ReturnType<typeof promotionsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await promotionsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: promotionsListQueryKey(options)
});

export const promotionsGetQueryKey = (options: Options<PromotionsGetData>) => createQueryKey('promotionsGet', options);

/**
 * A promotion record with its signature, key, state, delivery script and (for people) a signed bundle link
 */
export const promotionsGetOptions = (options: Options<PromotionsGetData>) => queryOptions<PromotionsGetResponse, PromotionsGetError, PromotionsGetResponse, ReturnType<typeof promotionsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await promotionsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: promotionsGetQueryKey(options)
});

/**
 * Confirm a delivery with the receipt line deliver.sh printed (people only); appends a signed confirmation record
 */
export const promotionsVerifyMutation = (options?: Partial<Options<PromotionsVerifyData>>): UseMutationOptions<PromotionsVerifyResponse, PromotionsVerifyError, Options<PromotionsVerifyData>> => {
    const mutationOptions: UseMutationOptions<PromotionsVerifyResponse, PromotionsVerifyError, Options<PromotionsVerifyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await promotionsVerify({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deliveryGetQueryKey = (options: Options<DeliveryGetData>) => createQueryKey('deliveryGet', options);

/**
 * Download a promotion's delivery bundle as a gzipped tar (people only; a signed link needs no session)
 *
 * The delivery bundle (cadence.delivery/1) of a promotion record as a .tar.gz: deliver.sh, record.json, record.sig, instance.pub, the model directory, decoding configuration and the smoke set, under one directory named after the record. A request signed by promotions.get (exp, viewer, sig) needs no session and is attributed to its viewer. Every download is written to the audit log. Agents and API keys are refused.
 *
 */
export const deliveryGetOptions = (options: Options<DeliveryGetData>) => queryOptions<DeliveryGetResponse, DeliveryGetError, DeliveryGetResponse, ReturnType<typeof deliveryGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await deliveryGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: deliveryGetQueryKey(options)
});

export const deploymentsListQueryKey = (options: Options<DeploymentsListData>) => createQueryKey('deploymentsList', options);

/**
 * The project's deployments, newest first, with stage, shadow progress and pending promotions
 */
export const deploymentsListOptions = (options: Options<DeploymentsListData>) => queryOptions<DeploymentsListResponse, DeploymentsListError, DeploymentsListResponse, ReturnType<typeof deploymentsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await deploymentsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: deploymentsListQueryKey(options)
});

/**
 * Deploy a model version's export as a shadow on the staging target, replayed nightly from a calls mount
 */
export const deploymentsNewMutation = (options?: Partial<Options<DeploymentsNewData>>): UseMutationOptions<DeploymentsNewResponse, DeploymentsNewError, Options<DeploymentsNewData>> => {
    const mutationOptions: UseMutationOptions<DeploymentsNewResponse, DeploymentsNewError, Options<DeploymentsNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deploymentsNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deploymentsGetQueryKey = (options: Options<DeploymentsGetData>) => createQueryKey('deploymentsGet', options);

/**
 * A deployment with its shadow progress, stage history and pending promotion
 */
export const deploymentsGetOptions = (options: Options<DeploymentsGetData>) => queryOptions<DeploymentsGetResponse, DeploymentsGetError, DeploymentsGetResponse, ReturnType<typeof deploymentsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await deploymentsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: deploymentsGetQueryKey(options)
});

/**
 * Promote a deployment to canary or production on a delivery target's slot (checks, then an approval, then a signed record and its bundle)
 */
export const deploymentsPromoteMutation = (options?: Partial<Options<DeploymentsPromoteData>>): UseMutationOptions<DeploymentsPromoteResponse, DeploymentsPromoteError, Options<DeploymentsPromoteData>> => {
    const mutationOptions: UseMutationOptions<DeploymentsPromoteResponse, DeploymentsPromoteError, Options<DeploymentsPromoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deploymentsPromote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Roll a canary or production deployment back to the slot's earlier production version (approval, signed record, small script)
 */
export const deploymentsRollbackMutation = (options?: Partial<Options<DeploymentsRollbackData>>): UseMutationOptions<DeploymentsRollbackResponse, DeploymentsRollbackError, Options<DeploymentsRollbackData>> => {
    const mutationOptions: UseMutationOptions<DeploymentsRollbackResponse, DeploymentsRollbackError, Options<DeploymentsRollbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deploymentsRollback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const shadowReplaysListQueryKey = (options: Options<ShadowReplaysListData>) => createQueryKey('shadowReplaysList', options);

/**
 * A shadow deployment's nightly replays, newest first, with the divergence of each night
 */
export const shadowReplaysListOptions = (options: Options<ShadowReplaysListData>) => queryOptions<ShadowReplaysListResponse, ShadowReplaysListError, ShadowReplaysListResponse, ReturnType<typeof shadowReplaysListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shadowReplaysList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shadowReplaysListQueryKey(options)
});

/**
 * Replay the newest unreplayed calls of a shadow deployment now, instead of waiting for the night (GPU spend)
 */
export const shadowReplaysNewMutation = (options?: Partial<Options<ShadowReplaysNewData>>): UseMutationOptions<ShadowReplaysNewResponse, ShadowReplaysNewError, Options<ShadowReplaysNewData>> => {
    const mutationOptions: UseMutationOptions<ShadowReplaysNewResponse, ShadowReplaysNewError, Options<ShadowReplaysNewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shadowReplaysNew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const shadowReplaysGetQueryKey = (options: Options<ShadowReplaysGetData>) => createQueryKey('shadowReplaysGet', options);

/**
 * One night's shadow replay with its most divergent segments (texts kept deploy.shadow_artifact_retention_days)
 */
export const shadowReplaysGetOptions = (options: Options<ShadowReplaysGetData>) => queryOptions<ShadowReplaysGetResponse, ShadowReplaysGetError, ShadowReplaysGetResponse, ReturnType<typeof shadowReplaysGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await shadowReplaysGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: shadowReplaysGetQueryKey(options)
});
